const translations = {
  language: "Langue",
  login: {
    welcome: "Bienvenue",
    ssoLogin: "Acc\u00E9der avec l\'e-mail de votre compte",
    detailsGeneric: "D\u00E9tails",
    customers: "Utilisateurs finaux",
      sendEmail: "Envoyer un e-mail",
      otpLogin: "Se connecter avec l\'e-mail",
      login: "Se connecter",
      changeEmail: "Utiliser une autre adresse e-mail",
      or: "OU",
      dontHaveAccount: "Vous n'avez pas de compte ?",
      requestAccess: "Demander un accès",
      accessRequestTitle: "Demander un accès",
    },
    domains: {
      customerAdminDeletionConfirm: "Voulez-vous supprimer cet utilisateur final ? L\'op\u00E9ration ne peut pas \u00EAtre annul\u00E9e",
      customerAdminDeletionSuccess: "Utilisateur final supprim\u00E9 avec succ\u00E8s",
      luckeyDomainsTitle: "Domaines",
      domainName: "Nom de domaine",
      domainDetails: "D\u00E9tails du domaine",
      domainConfigModifySuccess: "Configuration du domaine modifi\u00E9e et mise \u00E0 jour",
      domainConfigTitle: "Configurations - Activation/d\u00E9sactivation des fonctionnalit\u00E9s",
      domainConfigDescription: "Configuration du domaine au format JSON. Utilisez-la pour activer/d\u00E9sactiver les fonctionnalit\u00E9s du domaine",
      domainConfigGuide: "Guide de configuration du domaine",
      noUsersFoundTitle: "Liste d\'utilisateurs vide",
      domainUsersTitle: "Administrateurs du domaine",
      domainUsersDescription: "Impersonnez l\'un des gestionnaires d\'utilisateurs pour effectuer des op\u00E9rations de maintenance sur le domaine",
      domainUsersWarning: "ATTENTION : En vous faisant passer pour un utilisateur, vous pouvez apporter des modifications au syst\u00E8me, y compris irr\u00E9versibles. Utilisez la plus grande prudence",
      noUsersFoundDescription: "Aucun utilisateur trouv\u00E9 dans ce domaine",
      noDomainsFoundTitle: "Aucun domaine trouv\u00E9",
      noDomainFoundDescription: "La liste des domaines est vide. Si vous avez appliqu\u00E9 un filtre de recherche, essayez de le r\u00E9initialiser et r\u00E9essayez",
      impersonateSuccess: "Impersonation de l\'utilisateur r\u00E9ussie",
      domainSubsriptionTitle: "Abonnement du domaine",
      domainSubsriptionDescription: "Liste des abonnements du domaine : serrures, utilisateurs et expiration du domaine",
      expiration: "Expiration",
      totalNumber: "Nombre total",
      used: "\u00C9l\u00E9ments utilis\u00E9s",
      tooMuchElements: "AVERTISSEMENT : LE DOMAINE A D\u00C9PASS\u00C9 LA LIMITE D\'\u00C9L\u00C9MENTS TOTAUX",
      newDomain: "Nouveau domaine",
      externalReference: "R\u00E9f\u00E9rence externe",
      externalReferenceDetails: "Par exemple \"date-purchaseId\"",
      productDescription: "Le produit repr\u00E9sente la licence qui sera activ\u00E9e pour le nouveau domaine",
      productTitle: "Type d\'abonnement",
      extendDomain: "\u00C9tendre l\'abonnement du domaine",
      extendDomainDescription: "Prolongez votre domaine avec un add-on ou une cl\u00E9 de produit",
      domainInstallersTitle: "Installateurs du domaine",
      domainInstallersDescription: "Liste des utilisateurs installateurs sur les sites s\u00E9lectionn\u00E9s",
      domainDeletionTitle: "Supprimer le domaine",
      domainDeletionDescription: "Envoyer une demande de suppression de ce domaine",
      sendDeletionRequest: "Envoyer",
      domainDeletionConfirm: "Voulez-vous envoyer une demande de suppression de ce domaine ?",
      domainDeletionSuccess: "Demande envoy\u00E9e avec succ\u00E8s",
      customerDeletionTitle: "Supprimer l\'utilisateur final",
      customerDeletionConfirm: "Voulez-vous envoyer une demande de suppression de cet utilisateur final ?",
      customerDeletionSuccess: "Demande envoy\u00E9e avec succ\u00E8s",
      walletDeletionTitle: "Supprimer le portefeuille",
      walletDeletionConfirm: "Voulez-vous envoyer une demande de suppression de ce portefeuille ?",
      walletDeletionSuccess: "Demande envoy\u00E9e avec succ\u00E8s",
      verifyServiceStatus: "Statut du service",
      impersonateUser: "Impersonner l\'utilisateur",
      impersonate: "Impersonner",
      impersonateReadOnly: "Impersonner en mode lecture seule",
      domainAdditionalInfo: "Informations suppl\u00E9mentaires sur le domaine",
      domainAdditionalInfoDescription: "Fournissez des informations suppl\u00E9mentaires sur le domaine ici",
      additionalInfoSavedSuccessfully: "Notes suppl\u00E9mentaires enregistr\u00E9es avec succ\u00E8s",
      EASY: "Seulement Argo Locks",
      SMART: "Argo Locks + Gateway",
      ENTERPRISE: "V364 + Argo Locks",
      STANDARD: "Seulement V364 Locks",
      numberOfArgoLocks: "Argo",
      numberOfVegaLocks: "V364",
      numberOfGatewaysLocks: "Gateways",
      numberOfUsers: "Utilisateurs",
      numberOfLocks: "Cadenas intelligents",
      federatedDomain: "Domaine li\u00E9 \u00E0 : {{domain}}",
      federatedMasterDomain: "Domaine principal d\'un groupe",
      domainFederatedLicense: "Abonnement de site f\u00E9d\u00E9r\u00E9 : cet abonnement est unifi\u00E9 pour tous les domaines appartenant au domaine principal {{domain}}",
      federatedDomains: "Groupe de domaines",
      federatedDomainsDescription: "Le domaine appartient \u00E0 un groupe",
      installationMode: "Mode d\'installation",
      domainStandard: "Domaine h\u00E9rit\u00E9",
      domainWithCloudCredits: "Domaine avec crédits cloud",
      domainIrisRequired: "1RIS requis",
      domainIrisEnabled: "1RIS activ\u00E9",
      domainIrisEnable: "Activer 1RIS",
      domainIrisEnableConfirm: "Voulez-vous configurer 1RIS comme ACTIV\u00C9 pour ce domaine ?",
      editPlantDetails: "Modifier les détails de l'installation",
      editPlantDetailsSuccess: "Détails de l'installation mis à jour avec succès",
      zenDeskId: "ZenDesk Id",
      lockbaseId: "Lockbase Id",
      license1ris: "Licence 1RIS",
      domainsWithCloudCredits: "Domaines avec crédits cloud",
      domainsLegacy: "Domaines hérités",
      domainSecretsTitle: "Secrets du domaine",
      domainSecretsDescription: "Identifiants enregistrés sur ce domaine, affichés déchiffrés",
      domainSecretsEmpty: "Aucun secret enregistré pour ce domaine",
      domainSecretsError: "Impossible de charger les secrets du domaine",
      domainSecretsYes: "Oui",
      domainSecretsNo: "Non",
      domainSecretsCopied: "Copié",
      domainSecretsKey: "Clé",
      domainSecretsValue: "Valeur",
      domainSecretsAdd: "Ajouter une clé",
      domainSecretsEdit: "Modifier",
      domainSecretsFieldType: "Type de champ",
      domainSecretsFieldTypeText: "Texte",
      domainSecretsFieldTypePassword: "Mot de passe",
      domainSecretsFieldTypeUrl: "URL",
      domainSecretsFieldTypeBoolean: "Oui / Non",
      domainSecretsShowPassword: "Afficher la valeur",
      domainSecretsHidePassword: "Masquer la valeur",
      domainSecretsDelete: "Supprimer le champ",
      domainSecretsDeleteConfirm: "Supprimer le champ « {{key}} » ?",
      domainSecretsSaveError: "Impossible d'enregistrer les secrets du domaine",
      domainAppConfigurationTitle: 'Vérification de connexion personnalisée',
      domainAppConfigurationDescription: 'Points de terminaison HTTPS pour vérifier l\'e-mail utilisateur à la connexion',
      domainAppConfigurationUrlsLabel: 'URL de vérification',
      domainAppConfigurationUrlsHint: 'Une URL HTTPS par ligne. Utilisez {placeholder} pour un segment de chemin. Laissez vide pour effacer la configuration.',
      domainAppConfigurationFieldsLabel: 'Champs e-mail dans la réponse',
      domainAppConfigurationFieldsHint: 'Un nom de champ JSON par ligne (ex. email). Obligatoire lorsque des URL sont définies.',
      domainAppConfigurationLoadError: 'Impossible de charger la configuration de l\'application',
      domainAppConfigurationSaveError: 'Impossible d\'enregistrer la configuration de l\'application',
      domainAppConfigurationInvalidUrl: 'Une ou plusieurs URL sont invalides (HTTPS requis, pas d\'IP ni localhost)',
      domainAppConfigurationFieldsRequired: 'Au moins un champ e-mail est requis lorsque des URL de vérification sont configurées',
    },
    credits: {
      pricelistImport: 'Importer la liste de prix',
      pricelistImportTitle: 'Importer la liste de prix',
      pricelistChooseFile: 'Choisir un fichier (.xlsx, .xls, .csv)',
      pricelistChooseAnotherFile: 'Choisir un autre fichier',
      pricelistDownloadTemplate: 'Télécharger le modèle',
      pricelistSheet: 'Feuille',
      pricelistCompany: 'Société',
      pricelistSelectCompany: 'Sélectionnez la société dont vous voulez importer les lignes',
      pricelistError: 'Erreur lors de l\'importation de la liste de prix : {{message}}',
      pricelistStatus_NEW: 'Nouvelles',
      pricelistStatus_CHANGED: 'Modifiées',
      pricelistStatus_READONLY_CHANGED: 'Différences non modifiables',
      pricelistStatus_UNCHANGED: 'Inchangées',
      pricelistStatus_ERROR: 'Erreurs',
      pricelistStatus_SKIPPED: 'Ignorées',
      pricelistFilterAll: 'Toutes',
      pricelistColumnRow: 'Ligne',
      pricelistColumnMainTier: 'Main tier',
      pricelistColumnStatus: 'Statut',
      pricelistColumnDetails: 'Détails',
      pricelistOnlyInBackend: '{{count}} abonnements existants ne figurent pas dans le fichier et seront laissés intacts',
      pricelistParseErrors: 'Lignes en erreur ({{count}}), elles seront ignorées',
      pricelistRowError: 'Ligne {{row}} ({{sku}}) : {{message}}',
      pricelistShowingFirst: 'Affichage des {{count}} premières lignes sur {{total}}',
      pricelistNoRows: 'Aucune ligne pour ce filtre',
      pricelistApply: 'Appliquer {{count}} modifications',
      pricelistApplyTitle: 'Appliquer la liste de prix',
      pricelistApplyConfirm: '{{created}} abonnements de ce marketplace seront créés et {{updated}} mis à jour. Voulez-vous continuer ?',
      pricelistApplyConfirmWithErrors: '{{created}} abonnements de ce marketplace seront créés et {{updated}} mis à jour. {{errors}} lignes en erreur seront ignorées. Voulez-vous continuer ?',
      pricelistApplying: 'Application des modifications : {{done}} / {{total}}',
      pricelistResultSummary: 'Créés : {{created}} - Mis à jour : {{updated}} - Échoués : {{failed}}',
      pricelistFailedItem: '{{sku}} (main tier : {{tier}}) : {{message}}',
      customerPlantLockbaseId: 'ID Lockbase',
      customerPlantName: 'Nom du domaine',
      defaultMarketplace: 'Par défaut',
      setMarketplaceAsDefault: 'Définir comme par défaut',
      marketplaceSetAsDefaultConfirm: 'Voulez-vous définir ce marché comme par défaut ?',
      marketplaceSetAsDefaultError: 'Erreur lors de la définition du marché comme par défaut',
      notificationStartDate: 'Date de début de notification',
      notificationAssociatedServices: 'Services associés (optionnel)',
      notificationAssociatedServicesHelp: 'Sélectionnez un ou plusieurs services à associer à cette notification. Laissez ce champ vide pour les notifications générales de contrat.',
      selectContractServices: 'Sélectionner les services',
      notificationPeriodicMode: 'Mode de planification',
      notificationPeriodicModeStartDate: 'Démarrer à partir d\'une date spécifique',
      notificationPeriodicModeDayOfMonth: 'Démarrer à partir d\'un jour spécifique du mois',
      contractServicePrice: 'Prix',
      contractServiceOriginalPrice: 'Prix original',
      contractServiceCurrency: 'Devise',
      notificationRuleFormTitle: 'Règle de Notification de Contrat',
      notificationRuleType: 'Type de notification',
      notificationRuleType_ONCE: 'Unique',
      notificationRuleType_PERIODIC: 'Récurrente',
      notificationSpecificDate: 'Date de notification',
      notificationIntervalMonths: 'Répéter tous les',
      notificationDayOfMonth: 'Jour du mois',
      notificationEmails: 'Adresses e-mail',
      notificationEmailsHelp: 'Entrez les adresses e-mail séparées par des virgules',
      notificationAssociatedService: 'Service associé (optionnel)',
      notificationEnabled: 'Activé',
      nextRun: 'Prochaine exécution',
      schedule: 'Planification',
      notificationIntervalMonths_1: 'Chaque mois',
      notificationIntervalMonths_2: 'Tous les 2 mois',
      notificationIntervalMonths_3: 'Tous les 3 mois',
      notificationIntervalMonths_4: 'Tous les 4 mois',
      notificationIntervalMonths_6: 'Tous les 6 mois',
      notificationIntervalMonths_12: 'Chaque année',
      newNotificationRule: 'Nouvelle notification',
      editNotificationRule: 'Modifier la notification',
      deleteNotificationRule: 'Supprimer la notification',
      deleteNotificationRuleConfirm: 'Voulez-vous supprimer cette notification?',
      notificationRuleCreationConfirm: 'Voulez-vous créer la nouvelle notification?',
      notificationRuleEditConfirm: 'Vous êtes sur le point de modifier la notification. Êtes-vous sûr de vouloir continuer?',
      noNotificationRulesFound: 'Aucune notification trouvée',
      noNotificationRulesDescription: 'La liste des notifications est vide. Créez une nouvelle notification pour commencer.',
      selectContractService: 'Sélectionner un service',
      noContractServicesFound: 'Aucun service trouvé pour ce contrat',
      noServiceSelected: 'Aucun service sélectionné (notification générale)',
      generalContractNotification: 'Notification générale du contrat',
      serviceSpecificNotification: 'Notification spécifique au service',
      andMoreEmails: 'et {{count}} e-mails de plus',
      dayOfMonthValidationError: 'Le jour doit être compris entre 1 et 28',
      dayOfMonthHelp: 'Entrez un jour entre 1 et 28',
      createCustomerContractNotificationRuleError: 'Erreur lors de la création de la notification',
      editCustomerContractNotificationRuleError: 'Erreur lors de la modification de la notification',
      deleteCustomerContractNotificationRuleError: 'Erreur lors de la suppression de la notification',
      enterEmail: 'Entrez l\'adresse e-mail',
      domainsPeriodic: 'Domaines périodiques',
      andMorePlants: 'et {{count}} plus',
      andMoreServices: 'et {{count}} plus',
      customerContractSearch: 'Rechercher un contrat',
      domainPeriodic: 'Domaine périodique',
      customerPlantHostname: 'URL du domaine',
      customerPlantSolution: 'Solution',
      customerPlantManagement: 'Type de hosting',
      customerPlantModality: 'Modalité',
      customerPlantSubSegment: 'Sous-segment',
      customerPlantZendesk: 'ID Zendesk',
      customerPlantLoginData: 'Données de connexion',
      customerPlantLicense1ris: 'Numéro de série de la licence',
      openZendesk: 'Ouvrir Zendesk',
      totalInvoicedWithExplanation: 'Total facturé (Prix net x Quantité)',
      netPrice: 'Prix net',
      quantity: 'Quantité',
      totalInvoiced: 'Total facturé',
      customerPlantPlatform: 'Platform',
      customerPlantPlatformIris: '1RIS',
      customerPlantPlatformIrisArgo: '1RIS + ARGO',
      customerPlantPlatformArgo: 'ARGO',
      customerPlantSolutionLsa: 'LSA',
      customerPlantSolutionV364: 'V364',
      customerPlantSolutionLuckey: 'Luckey',
      customerPlantSolutionV364Classic: 'V364 Classic',
      customerPlantSolutionArgo: 'Argo',
      customerPlantSolutionFlex: 'Flex',
      customerPlantSolutionLwc: 'LWC',
      customerPlantSolutionAtg: 'ATG',
      customerPlantSolutionVar: 'VAR',
      customerPlantSolutionMechanic: 'Mechanic',
      customerPlantSolutionOther: 'Other',
      customerPlantManagementOnPremiseClassic: 'On Premise::Classic',
      customerPlantManagementOnPremiseVmNative: 'On Premise::VM Native',
      customerPlantManagementOnPremiseVmDockerBased: 'On Premise::VM Docker Based',
      customerPlantManagementOnPremiseContainer: 'On Premise::Container',
      customerPlantManagementOnPremiseOther: 'On Premise::Other',
      customerPlantManagementSaasAzure: 'SaaS::Azure',
      customerPlantManagementSaasAws: 'SaaS:AWS',
      customerPlantManagementOther: 'Other',
      customerPlantModalityPeriodic: 'Périodique',
      customerPlantModalityCredits: 'Crédits',
      createCustomerDomainError: 'Impossible de créer ou modifier le domaine. Vérifiez les données saisies et réessayez',
      noCustomerDomainFindTitle: 'Aucun domaine trouvé',
      noCustomerDomainFindDescription: 'La liste des domaines est vide. Si vous avez défini un filtre de recherche, essayez de le réinitialiser et réessayez',
      editCustomerDomain: 'Modifier le domaine',
      editCustomerDomainConfirm: 'Vous êtes sur le point de modifier les données du domaine. Êtes-vous sûr de vouloir continuer?',
      newCustomerDomain: 'Nouveau domaine',
      customerDomainCreationConfirm: 'Voulez-vous créer le nouveau domaine?',
      deleteCustomerDomainError: 'Impossible de supprimer le domaine. Veuillez réessayer',
      deleteCustomerDomainConfirm: 'Voulez-vous supprimer le domaine?',
      customerContractActivationDate: 'Date d\'activation',
      customerContractDeactivationDate: 'Date de désactivation',
      customerContractDetails: 'Détails du contrat',
      contractServices: 'Services',
      contractService: 'Service',
      contractDocuments: 'Documents',
      contractNotifications: 'Notifications',
      deleteCustomerContract: 'Supprimer le contrat',
      deleteCustomerContractConfirm: 'Voulez-vous supprimer le contrat?',
      deleteCustomerContractError: 'Impossible de supprimer le contrat. Veuillez réessayer',
      associateNewPlantToContract: 'Associer un nouveau domaine',
      addCustomerPlantMessage: 'Sélectionnez le domaine à ajouter à ce contrat',
      removeCustomerPlantFromContract: 'Supprimer',
      removeCustomerPlantFromContractConfirm: 'Voulez-vous supprimer le domaine du contrat?',
      addCustomerPlantToContractError: 'Impossible d\'ajouter le domaine au contrat. Veuillez réessayer',
      removeCustomerPlantFromContractError: 'Impossible de supprimer le domaine du contrat. Veuillez réessayer',
      customerContractStatus_ACTIVE: 'Actif',
      customerContractStatus_NOT_ACTIVE: 'Inactif',
      customerContractStatus_CANCELLED: 'Annulé',
      downloadDocument: 'Télécharger',
      associateNewDocumentToContract: 'Ajouter un document',
      addDocument: 'Ajouter un document',
      addDocumentMessage: 'Sélectionnez le document à ajouter à ce contrat',
      documentName: 'Nom du fichier',
      addDocumentToContractError: 'Impossible d\'ajouter le document au contrat. Veuillez réessayer',
      deleteContractDocumentConfirm: 'Voulez-vous supprimer ce document?',
      deleteContractDocumentError: 'Impossible de supprimer le document. Veuillez réessayer',
      noCustomerContractDocumentFindTitle: 'Aucun document trouvé',
      noCustomerContractDocumentFindDescription: 'La liste des documents est vide. Si vous avez défini un filtre de recherche, essayez de le réinitialiser et réessayez',
      noCustomerContractServiceFindTitle: 'Aucun service trouvé',
      noCustomerContractServiceFindDescription: 'La liste des services est vide. Si vous avez défini un filtre de recherche, essayez de le réinitialiser et réessayez',
      editCustomerContractService: 'Modifier le service',
      editCustomerContractServiceConfirm: 'Vous êtes sur le point de modifier les données du service. Êtes-vous sûr de vouloir continuer?',
      createCustomerContractServiceError: 'Impossible de créer le service. Vérifiez les données saisies et réessayez',
      deleteCustomerContractServiceError: 'Impossible de supprimer le service. Veuillez réessayer',
      deleteCustomerContractServiceConfirm: 'Voulez-vous supprimer le service?',
      newCustomerContractService: 'Nouveau service',
      customerContractServiceCreationConfirm: 'Voulez-vous créer le nouveau service?',
      customerContractServiceFormTitle: 'Service de Contrat Client',
      duplicateCustomerContractServiceFormTitle: 'Dupliquer le Service de Contrat Client',
      customerDomainFormTitle: 'Système',
      manageDomainFromWallet: 'Vous pouvez gérer ce domaine depuis sa page wallet: {{walletName}}',
      selectService: 'Sélectionner un service',
      noServicesFound: 'Aucun service trouvé',
      serviceSubject: 'Sujet',
      serviceGroupFamily: 'Famille de groupe',
      serviceType: 'Type',
      searchContractService: 'Rechercher un service par code, sujet, famille de groupe...',
      contractServiceCode: 'Code',
      customerServiceSelloutPONumber: 'Numéro de PO de vente',
      customerServiceSfdcId: 'ID SFDC',
      customerContractServiceNotes: 'Notes',
      customerContractServiceStatus: 'Statut',
      customerContractServiceStatus_WAITING_FOR_ACTIVATION: 'En attente d\'activation',
      customerContractServiceStatus_ACTIVE: 'Actif',
      customerContractServiceStatus_PAUSED: 'En pause',
      customerContractServiceStatus_CANCELLED: 'Annulé',
      customerContractServiceStatus_INACTIVE: 'Inactif',
      customerContractServiceStatus_WAITING_TO_BE_DONE: 'En attente de réalisation',
      customerContractServiceStatus_WORK_IN_PROGRESS: 'En cours',
      customerContractServiceStatus_DONE: 'Terminé',
      sfdcIdAndSelloutPo: 'ID SFDC | PO de vente',
      groupFamilySubjectCode: 'Service',
      activationDeactivationStatus: 'Statut',
      noPlantsAssociated: 'Aucun domaine associé',
      noServicesAssociated: 'Aucun service associé',
      loadingServices: 'Chargement des services...',
      chooseFile: 'Choisir un fichier',
      exportCustomerContractsCSV: 'Exporter CSV',
      exportCustomerContractsXLSX: 'Exporter Excel',
      exportCustomerContractsError: 'Erreur lors de l\'exportation CSV',
      exportCustomerContractServicesCSV: 'Exporter CSV',
      exportCustomerContractServicesError: 'Erreur lors de l\'exportation CSV',
      customerAndContract: 'Client | Contrat',
      customerContract: 'Contrat',
      customer: 'Client',
      customerContractServiceSearch: 'Rechercher un service',
      customerContractName: 'Nom du contrat',
      customerContractStatus: 'Statut du contrat',
      customerContractSigningDate: 'Date de signature',
      customerContractExpirationDate: 'Date d\'expiration',
      marketplaces: "March\u00E9s",
      searchMarketplace: "Rechercher dans le march\u00E9...",
      marketplaceName: "Nom du march\u00E9",
      luckeyMarketplaceTitle: "March\u00E9s Luckey",
      noMarketplaceFoundTitle: "Aucun march\u00E9 trouv\u00E9",
      noMarketplaceFoundDescription: "La liste des march\u00E9s est vide. Si vous avez appliqu\u00E9 un filtre de recherche, essayez de le r\u00E9initialiser et r\u00E9essayez",
      newMarketplace: "Nouveau march\u00E9",
      marketplaceCreationConfirm: "Voulez-vous cr\u00E9er le nouveau march\u00E9 ?",
      createMarketplace: "Cr\u00E9er le march\u00E9",
      marketplaceDetails: "D\u00E9tails du march\u00E9",
      editMarketplaceCreationConfirm: "Vous \u00EAtes sur le point de modifier les donn\u00E9es du march\u00E9. \u00CAtes-vous s\u00FBr de vouloir continuer ?",
      editMarketplace: "Modifier le march\u00E9",
      searchCustomer: "Rechercher un utilisateur final...",
      customerName: "Nom de l\'utilisateur final",
      luckeyCustomersTitle: "Utilisateurs finaux Luckey",
      noCustomerFindTitle: "Aucun utilisateur final trouv\u00E9",
      noCustomerFindDescription: "La liste des utilisateurs finaux est vide. Si vous avez appliqu\u00E9 un filtre de recherche, essayez de le r\u00E9initialiser et r\u00E9essayez",
      noCustomerContractFindTitle: 'Aucun contrat de service trouvé',
      noCustomerContractFindDescription: 'La liste des contrats de service est vide. Si vous avez appliqué un filtre de recherche, essayez de le réinitialiser et réessayez',
      newCustomer: "Nouvel utilisateur final",
      customerCreationConfirm: "Voulez-vous cr\u00E9er le nouvel utilisateur final ?",
      newUser: "Nouvel utilisateur",
      userCreationConfirm: "Voulez-vous cr\u00E9er le nouvel utilisateur ?",
      createCustomer: "Cr\u00E9er un utilisateur final",
      customerDetails: "D\u00E9tails de l\'utilisateur final",
      editCreationConfirm: "Vous \u00EAtes sur le point de modifier les donn\u00E9es de l\'utilisateur final. \u00CAtes-vous s\u00FBr de vouloir continuer ?",
      editCustomer: "Modifier l\'utilisateur final",
      editCreationUserConfirm: "Vous \u00EAtes sur le point de modifier les donn\u00E9es de l\'utilisateur. \u00CAtes-vous s\u00FBr de vouloir continuer ?",
      editCustomerContract: 'Modifier le contrat de service',
      editCustomerContractConfirm: 'Vous \u00EAtes sur le point de modifier les donn\u00E9es du contrat de service. \u00CAtes-vous s\u00FBr de vouloir continuer ?',
      newCustomerContract: 'Nouveau contrat de service',
      customerContractCreationConfirm: 'Voulez-vous cr\u00E9er le nouveau contrat de service ?',
      editUser: "Modifier l\'utilisateur",
      customerWallets: "Portefeuilles de {{customerName}}",
      wallets: 'Portefeuilles',
      contracts: 'Contrats de service',
      plants: 'Domaines',
      newWallet: "Nouveau portefeuille",
      walletCreationConfirm: "Voulez-vous cr\u00E9er un nouveau portefeuille pour l\'utilisateur final s\u00E9lectionn\u00E9 ?",
      createWallet: "Cr\u00E9er le portefeuille",
      editWallet: "Modifier le portefeuille",
      walletEditConfirm: "Voulez-vous modifier le portefeuille s\u00E9lectionn\u00E9 ?",
      noWalletFoundTitle: "Aucun portefeuille trouv\u00E9",
      noWalletFoundDescription: "Aucun portefeuille trouv\u00E9 pour l\'utilisateur final s\u00E9lectionn\u00E9",
      walletDetails: "D\u00E9tails du portefeuille",
      rechargeWallet: "Recharger",
      walletRechargeHistory: "Historique des recharges",
      rechargeRowTitle: "Cr\u00E9dits modifi\u00E9s",
      rechargeCreditsDescription: "Le portefeuille a \u00E9t\u00E9 recharg\u00E9 avec {{credits}} cr\u00E9dits",
      rechargeCardDetails: "D\u00E9tails de la recharge",
      systemParameters: "Liste des prix",
      systemSubscriptions: "Abonnements",
      systemSubscriptionsDescription: "Voici les abonnements du syst\u00E8me. Cr\u00E9ez-en de nouveaux ou assignez-les \u00E0 un domaine existant",
      newSubscription: "Nouvel abonnement",
      editSubscription: "Modifier l\'abonnement",
      noSystemSubscriptionFoundTitle: "Aucun abonnement trouv\u00E9",
      noSystemSubscriptionFoundDescription: "Il n\u2019y a aucun abonnement du syst\u00E8me pouvant \u00EAtre assign\u00E9 \u00E0 un domaine",
      products: "Abonnements h\u00E9rit\u00E9s",
      rechargeCards: "Cartes de recharge",
      noSystemCardFoundTitle: "Aucune carte de recharge trouv\u00E9e",
      noSystemCardFoundDescription: "Il n\u2019y a aucune carte de recharge dans le syst\u00E8me. Cr\u00E9ez-en de nouvelles pour commencer \u00E0 recharger les portefeuilles des utilisateurs finaux",
      newCard: "Nouvelle carte de recharge",
      cardStatusUsed: "Utilis\u00E9e",
      rechargeCardCreditsDetails: "Cette carte de recharge vaut {{credits}} cr\u00E9dits",
      cardStatusUnused: "Non utilis\u00E9e",
      cardStatusInactive: "D\u00E9sactiv\u00E9e",
      enableCard: "Activer",
      disabledCardTooltip: "La carte de recharge sera activ\u00E9e d\u00E8s que vous recevrez la facture ISEO associ\u00E9e",
      newTierSubscription: "Nouvel abonnement principal",
      pluginAndService: "Add-on et services",
      newPluginSubscription: "Nouvel add-on ou service",
      tierSubscription: "Abonnement principal",
      walletSubscriptions: "Abonnements",
      noWalletSubscriptionFoundTitle: "Aucun abonnement trouv\u00E9",
      noWalletSubscriptionFoundDescription: "Ce portefeuille n\u2019a aucun abonnement associ\u00E9",
      newWalletSubscription: "Associer un nouvel abonnement",
      editWalletSubscription: "Modifier l\u2019abonnement",
      newWalletPluginSubscription: "Associer un nouvel add-on ou service",
      walletConsumption: "Consommation",
      noWalletUsageFoundTitle: "Aucune donn\u00E9e trouv\u00E9e",
      noWalletUsageFoundDescription: "Aucune donn\u00E9e de consommation pour ce portefeuille",
      ACTIVATION: "Co\u00FBt d\u2019activation du domaine ou de l\u2019add-on",
      DAILY_USAGE: "Consommation quotidienne",
      creditConsumptionType: "Type de consommation",
      consumptionCreditsDescription: "Le portefeuille a consomm\u00E9 {{credits}}",
      consumptionRowTitle: "Consommation du portefeuille",
      walletPlants: "Domaines",
      noWalletPlantFoundTitle: "Aucun domaine trouv\u00E9",
      noWalletPlantFoundDescription: "Aucun domaine associ\u00E9 \u00E0 ce portefeuille",
      newWalletPlant: "Nouveau domaine",
      deleteWalletSubscription: "Supprimer l\u2019abonnement",
      editCard: "Modifier la carte de recharge",
      rechargeDetails: "D\u00E9tails de la recharge",
      exportWalletsUsageCSV: "Exporter le CSV de l\u2019utilisation des cr\u00E9dits",
      exportWalletsCreditUsageCSV: "Exporter le cr\u00E9dit du portefeuille",
      PENDING: "En attente",
      ACTIVE: "Actif",
      READY_TO_ACTIVATE: "Pr\u00EAt \u00E0 activer",
      DISABLED: "D\u00E9sactiv\u00E9",
      walletStatus: "Statut du portefeuille",
      exportManagersCSV: "Exporter les gestionnaires",
      needCreditsToCreatePlant: "Vous devez disposer de cr\u00E9dits dans ce portefeuille pour cr\u00E9er un nouveau domaine",
      customerPlants: 'Impiants',
    },
    sales: {
      hardwareSalesInfo: "Infos de vente de mat\u00E9riel",
      domain: "Domaine",
      hardwareId: "ID du mat\u00E9riel",
      hardwareName: "Nom du mat\u00E9riel",
      hardwareSerialNumber: "Num\u00E9ro de s\u00E9rie du mat\u00E9riel",
      hardwareModel: "Mod\u00E8le du mat\u00E9riel",
      hardwareVendor: "Ligne de produit du mat\u00E9riel",
      hardwareType: "Type de mat\u00E9riel",
      sfdcId: "SFDC-ID",
      iseoSelloutOrderId: "ID de commande de vente ISEO",
      iseoSelloutOrderDate: "Date de commande de vente ISEO",
      iseoSelloutInvoiceId: "ID de facture de vente ISEO",
      iseoSelloutInvoiceDate: "Date de facture de vente ISEO",
      sofiaCustRef: "R\u00E9f. client (processus Sofia)",
      unreconciledHardware: "Mat\u00E9riel non rapproch\u00E9",
      hardwareWithSalesInfo: "Mat\u00E9riel avec infos de vente",
      actions: "Actions",
      addSalesInfo: "Ajouter des infos de vente",
      editSalesInfo: "Modifier les infos de vente",
      iseoSelloutOrder: "Commande de vente ISEO",
      iseoSelloutInvoice: "Facture de vente ISEO",
      selectedSalesInfoError: "Attention ! La s\u00E9lection n\u2019est pas homog\u00E8ne. \u00CAtes-vous s\u00FBr de vouloir continuer ?"
    },
    errors: {
      errorPreviewingFile: 'Erreur lors de l\'anteprima du fichier. Veuillez vérifier le format du fichier ou essayer avec un fichier différent',
      fileFormatNotSupported: 'Format de fichier non supporté',
      deleteWalletSubscriptionError: "Une erreur est survenue lors de la modification de l\u2019abonnement. Veuillez r\u00E9essayer ou contacter notre \u00E9quipe de support",
      modifyVarOpportunityError: "Une erreur est survenue lors de la modification du devis. Veuillez r\u00E9essayer",
      error: "Erreur",
      loginFailed: "La session a expir\u00E9. Veuillez vous reconnecter",
      loginGoogleFailedTitle: "\u00C9chec de la connexion avec Google",
      loginGoogleFailed: "Assurez-vous d\u2019\u00EAtre connect\u00E9 \u00E0 votre compte Google ou essayez d\u2019ouvrir cette page dans une session Google Chrome avec votre compte GSuite de Sofia",
      loginJagoGoogleFailedTitle: "\u00C9chec de la connexion Jago Google",
      loginJagoGoogleFailed: "Assurez-vous d\u2019avoir un utilisateur dans Jago correspondant \u00E0 votre compte GSuite de Sofia et r\u00E9essayez",
      getDomainDetailsError: "Une erreur est survenue lors de la r\u00E9cup\u00E9ration de la configuration des domaines. Veuillez r\u00E9essayer ou contacter le support de Sofia",
      updateDomainConfigError: "Une erreur est survenue lors de l\u2019enregistrement de la configuration du site. Veuillez r\u00E9essayer ou contacter le support de Sofia",
      updatePlantThemeError: "Une erreur est survenue lors de l\u2019enregistrement du th\u00E8me du site. Veuillez r\u00E9essayer ou contacter le support de Sofia",
      impersonateDomainUserError: "Une erreur est survenue lors de l\u2019impersonation de l\u2019utilisateur. Veuillez v\u00E9rifier que l\u2019utilisateur est actif et r\u00E9essayer ou contacter le support de Sofia",
      createDomainError: "Une erreur est survenue lors de la cr\u00E9ation du nouveau domaine",
      addDomainPluginError: "Une erreur est survenue lors de l\u2019extension du domaine",
      addUserDomainError: "Impossible de cr\u00E9er l\u2019utilisateur. V\u00E9rifiez si l\u2019utilisateur existe d\u00E9j\u00E0 dans le domaine ou si le domaine dispose d\u2019un abonnement valide",
      deleteDomainUserError: "Impossible de supprimer l\u2019utilisateur. Veuillez réessayer",
      errorSaveAdditionalInfo: "Impossible de mettre \u00E0 jour les informations sur le domaine s\u00E9lectionn\u00E9",
      createCustomerError: "Impossible de cr\u00E9er l\u2019utilisateur final. V\u00E9rifiez si l\u2019utilisateur existe d\u00E9j\u00E0 et r\u00E9essayez",
      createUserError: "Impossible de cr\u00E9er l\u2019utilisateur. V\u00E9rifiez si l\u2019utilisateur existe d\u00E9j\u00E0 et r\u00E9essayez",
      createVarUserError: "Impossible de cr\u00E9er l\u2019utilisateur VAR. V\u00E9rifiez si l\u2019utilisateur existe d\u00E9j\u00E0 et r\u00E9essayez",
      createPlantThemeError: "Impossible de cr\u00E9er le th\u00E8me du site. V\u00E9rifiez les donn\u00E9es et r\u00E9essayez",
      updateVarError: "Impossible de mettre \u00E0 jour. V\u00E9rifiez les donn\u00E9es et r\u00E9essayez",
      getCustomerDetailsError: "Impossible d\u2019obtenir les d\u00E9tails de l\u2019utilisateur final. Veuillez r\u00E9essayer",
      createCustomerContractError: 'Impossible de créer le contrat de service. Vérifiez les données et réessayez',
      getCustomerContractDetailsError: 'Impossible de récupérer les détails du contrat de service. Veuillez réessayer',
      getVarDetailsError: "Impossible d\u2019obtenir les d\u00E9tails du VAR. Veuillez r\u00E9essayer",
      getPlantThemeDetailsError: "Impossible d\u2019obtenir les d\u00E9tails du th\u00E8me du site. Veuillez r\u00E9essayer",
      getProductInfoPostDetailsError: "Impossible d\u2019obtenir l\u2019article. Veuillez r\u00E9essayer",
      required: "Requis",
      deleteDomainRequestError: "Impossible d\u2019envoyer la demande. Veuillez r\u00E9essayer",
      deleteWalletRequestError: "Impossible d\u2019envoyer la demande. Veuillez r\u00E9essayer",
      deleteCustomerRequestError: "Impossible d\u2019envoyer la demande. Veuillez r\u00E9essayer",
      enableIrisDomainRequestError: "Impossible d'envoyer la demande. Veuillez réessayer",
      updatePlantDetailsError: "Impossible de mettre à jour les détails de l'installation. Veuillez réessayer",
      createCustomerWalletError: "Impossible de créer le nouveau portefeuille. Veuillez réessayer",
      editCustomerWalletError: "Impossible de modifier le nouveau portefeuille. Veuillez r\u00E9essayer",
      getWalletDetailsError: "Impossible de r\u00E9cup\u00E9rer les d\u00E9tails du portefeuille. Veuillez r\u00E9essayer",
      openSystemParametersError: "Impossible d\u2019ouvrir les param\u00E8tres du syst\u00E8me. Veuillez r\u00E9essayer",
      createSubscriptionError: "Impossible de cr\u00E9er l\u2019abonnement. Veuillez r\u00E9essayer",
      createCardError: "Une erreur est survenue lors de la cr\u00E9ation de la carte de recharge. Veuillez r\u00E9essayer",
      createVarOpportunityError: "Une erreur est survenue lors de la cr\u00E9ation. Veuillez r\u00E9essayer",
      editVarOpportunityError: "Une erreur est survenue lors de l\u2019op\u00E9ration. Veuillez r\u00E9essayer",
      rechargeWalletError: "Une erreur est survenue lors de la recharge du portefeuille. Veuillez r\u00E9essayer",
      deleteCardError: "Une erreur est survenue lors de la suppression de la carte de recharge. Veuillez r\u00E9essayer",
      enableCardError: "Une erreur est survenue lors de la mise \u00E0 jour de la carte de recharge. Veuillez r\u00E9essayer",
      deletePlantThemeError: "Une erreur est survenue lors de la suppression. Veuillez r\u00E9essayer",
      deleteVarUserError: "Une erreur est survenue lors de la suppression. Veuillez r\u00E9essayer",
      deleteVarUserErrorOpportunities: "Cet utilisateur est le propri\u00E9taire d\u2019au moins un devis, il ne peut donc pas \u00EAtre supprim\u00E9. Veuillez r\u00E9assigner les devis associ\u00E9s \u00E0 cet utilisateur et r\u00E9essayer.",
      deleteVarOpportunityError: "Une erreur est survenue lors de la suppression. Veuillez r\u00E9essayer",
      rejectVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      approveVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      syncsfdcidVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      upgradeVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      winVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      loseVarOpportunityError: "Une erreur est survenue lors de la mise \u00E0 jour du devis. Veuillez r\u00E9essayer",
      deleteUserError: "Une erreur est survenue lors de la suppression. Veuillez r\u00E9essayer",
      createWalletSubscriptionError: "Une erreur est survenue lors de l\u2019association de l\u2019abonnement au portefeuille. Veuillez r\u00E9essayer",
      createWalletPlantError: "Une erreur est survenue lors de la cr\u00E9ation du domaine pour le portefeuille. Veuillez r\u00E9essayer",
      walletActionErrorNotEnoughCreditsTitle: "Cr\u00E9dits insuffisants",
      walletActionErrorNotEnoughCredits: "Le portefeuille ne dispose pas de cr\u00E9dits suffisants pour effectuer l\u2019op\u00E9ration. V\u00E9rifiez l\u2019op\u00E9ration et r\u00E9essayez",
      warningMinCreditsCard: "Attention ! Nombre minimum de cr\u00E9dits requis = {{credits}}",
      loginJagoOTPEmailFailedTitle: "Erreur d\u2019envoi de l\u2019e-mail",
      loginJagoOTPEmailFailed: "Une erreur est survenue lors de l\u2019envoi de l\u2019e-mail, r\u00E9essayez dans 5 minutes",
      loginJagoOTPFailedTitle: "Erreur de v\u00E9rification du code",
      loginJagoOTPFailed: "La v\u00E9rification du code d\u2019acc\u00E8s a \u00E9chou\u00E9. Veuillez v\u00E9rifier le code ou r\u00E9essayer dans 5 minutes.",
      addonV364missing: "Le complément V364 n\u2019a pas pu \u00EAtre trouv\u00E9 dans le syst\u00E8me, veuillez signaler cette erreur pour obtenir de l\u2019aide."
    },
    gateways: {
      deployments: 'Deployments',
      showDeployments: 'Afficher les Deployments',
      showLogs: 'Show Logs',
      gatewayLogsTitle: 'Gateway logs',
      gatewayLogsTimestamp: 'Time',
      gatewayLogsLevel: 'Level',
      gatewayLogsLevelFilter: 'Niveau de journal',
      gatewayLogsLevelFilterAll: 'Tous',
      gatewayLogsLevelError: '4 (Erreur)',
      gatewayLogsLevelInfo: '6 (Info)',
      gatewayLogsSummary: 'Summary',
      gatewayLogsContext: 'Context',
      gatewayLogsFullLine: 'Full line',
      gatewayLogsMessage: 'Message',
      gatewayLogsEmpty: 'No log lines found for this device in the selected time range.',
      gatewayLogsRefresh: 'Refresh',
      gatewayLogsDeviceIdLabel: 'Device',
      gatewayLogsFilterContext: 'Filter context',
      gatewayLogsFilterContextPlaceholder: 'Contains…',
      gatewayLogsFilterText: 'Search in log',
      gatewayLogsFilterTextPlaceholder: 'Filter in full line, summary…',
      gatewayLogsDateFrom: 'From',
      gatewayLogsDateTo: 'To',
      gatewayLogsApplyRange: 'Apply range',
      gatewayLogsRangeHint: 'Max span between From and To dates: 8 calendar days',
      gatewayLogsNoFilterMatch: 'No rows match the current filter.',
      gatewayLogsErrorGeneric: 'Could not load gateway logs from the server. Please try again.',
      getGatewayDeploymentsError: 'Une erreur est survenue lors de la récupération des Deployments. Veuillez réessayer',
      createdBy: 'Créé par',
      noGatewayFoundTitle: 'Aucun HyperGate trouvé',
      noGatewayFoundDescription: 'La liste des HyperGate est vide. Si vous avez défini un filtre de recherche, essayez de le modifier et de réessayer',
      gatewayName: 'Nom HyperGate',
      luckeyGatewaysTitle: 'Système HyperGates',
      lastConnectionDate: 'Dernière connexion: {{ date }}',
      gatewaysDevices: 'Dispositifs',
      gatewaysArtifacts: 'Artifacts',
      gatewaysDeployments: 'Deployments',
      noArtifactFoundTitle: 'Aucun Artifact trouvé',
      noArtifactFoundDescription: 'La liste des Artifacts est vide. Si vous avez défini un filtre de recherche, essayez de le modifier et de réessayer',
      noDeploymentFoundTitle: 'Aucun Deployment trouvé',
      noDeploymentFoundDescription: 'La liste des Deployments est vide. Si vous avez défini un filtre de recherche, essayez de le modifier et de réessayer',
      newDeployment: 'Nouveau Deployment',
      deploymentScheduledAt: 'Deployment planifié à',
      gatewaysArtifact: 'Artifact',
      gateways: 'Gateways',
      artifactName: 'Nom Artifact',
      createNewDeployment: 'Créer un nouveau Deployment',
      selectHyperGates: 'Sélectionner HyperGates',
      allGateways: 'Déployer sur tous les HyperGates',
      HYPERGATE_PRO: 'HyperGate Pro',
      HYPERGATE_ISEO: 'HyperGate Lite',
      deploymentDetail: 'Détails du Deployment',
      noDeploymentDetailedFound: 'Aucun Gateway trouvé pour le Deployment',
      noDeploymentDetailedFoundDescription: 'La liste des gateways pour ce Deployment est vide',
      DONE: 'Terminé',
      PENDING: 'En cours de libération',
      IN_PROGRESS: 'En installation',
      ERROR: 'Erreur',
      deviceId: 'ID du dispositif',
      name: 'Nom',
      gatewayVersion: 'Version',
      iseoSdkVersion: 'ISEO SDK',
      kernelVersion: 'Version du noyau',
      serialNumber: 'Numéro de série',
      noGatewaysFound: 'Aucun Gateway trouvé',
      noGatewaysFoundDescription: 'La liste des gateways est vide. Essayez de modifier le filtre de recherche et réessayer',
      noDeploymentFound: 'Aucun Deployment trouvé',
      noArtifactFound: 'Aucun Artifact trouvé',
    },
    forms: {
      createResource: 'Créer une ressource',
      subscriptionCategory: 'Catégorie',
      createNew: 'Nouveau',
      aggregateByMonth: 'Agrégation par mois',
      findOutMore: 'En savoir plus',
      findOutMoreAboutThisFeature: 'En savoir plus sur cette fonctionnalité',
      extraCredentials: 'Credentiels supplémentaires',
      invitations: 'Invitations actives',
      anonymizeAllEvents: 'Supprimer les données utilisateur des événements de serrature et de gestion',
      deleteAllStandardDevices: 'Supprimer toutes les cartes RFID, PIN et F9000 assignées à cet utilisateur',
      numberOfDomains: 'Domaines',
      walletDetails: 'Détails du portefeuille',
      subscriptionDetails: 'Détails de l\'abonnement',
      smartLocks: 'Serratures',
      users: 'Utilisateurs',
      numberOfElements: 'Éléments',
      segment: 'Segment',
      otpLoginOnly: 'Activer la connexion avec OTP uniquement pour ce système',
      varEditSuccess: 'VAR mis à jour avec succès',
      synchronizationCompleted: 'Synchronisation terminée avec succès',
      sfdcSync: 'Synchronisation SFDC',
      customerVatVerificationTitle: 'Récupérer les données du client depuis les systèmes ISEO',
      customerAdditionalData: 'Données supplémentaires',
      verify: 'Vérifier',
      otp: 'OTP',
      notVisible: "Non visible",
      visible: "Visible",
      exportAllUsers: "Exporter les utilisateurs",
      montlyBurnRate: "{{credits}}/mois",
      nextRechargeForecast: "Prochaine recharge pr\u00E9vue avec la consommation actuelle ~{{date}}",
      creditsFinishedInDate: "Crédits terminés le {{date}}",
      lastUpdate: "Derni\u00E8re mise \u00E0 jour {{time}}",
      rowsPerPage: "Lignes par page",
      rolePermissions: "Permissions de r\u00F4le",
      permissionsDetails: "D\u00E9tails des permissions",
      clusterAndIseoCompany: "Cluster et entreprise ISEO",
      createCardSuccess: "Carte de recharge cr\u00E9\u00E9e avec succ\u00E8s",
      cardDetails: "D\u00E9tails de la carte",
      status: "Statut",
      customerInfo: "Infos client",
      details: "D\u00E9tails",
      costs: "Co\u00FBts",
      hostName: "Nom d\'h\u00F4te",
      domainType: "Type",
      user: "Utilisateur",
      logoutConfirmation: "Voulez-vous vraiment vous d\u00E9connecter ?",
      send: "Envoyer",
      askQuestion: "Nous contacter",
      ticketOpenSuccessfully: "Votre question a \u00E9t\u00E9 soumise \u00E0 notre \u00E9quipe ! Un de nos collaborateurs vous contactera sous peu.",
      ticketOpenError: "Une erreur est survenue lors de l\'envoi de la demande. Veuillez r\u00E9essayer",
      writeUsAQuestionDescription: "Vous avez une question ? N\'h\u00E9sitez pas \u00E0 nous \u00E9crire, et un de nos sp\u00E9cialistes produit sera pr\u00EAt \u00E0 vous aider pour toute demande.",
      deviceType: "Type d\'appareil",
      createNewMarketplace: "Nouveau march\u00E9",
      createNewCustomer: "Nouveau",
      firstName: "Pr\u00E9nom",
      lastName: "Nom",
      email: "E-mail",
      contactEmail: "E-mail de contact",
      marketplace: "Marché",
      open: "Ouvrir",
      add: "Ajouter",
      actions: "Actions",
      search: "Rechercher",
      remove: "Supprimer",
      error: "Erreur",
      copy: "Copier",
      cancel: "Annuler",
      confirm: "Confirmer",
      warning: "Attention",
      reset: "R\u00E9initialiser",
      close: "Fermer",
      save: "Enregistrer",
      delete: "Supprimer",
      duplicate: "Dupliquer",
      deleteRequest: "Envoyer une demande de suppression",
      deleteAdminOnly: "Supprimer (admin)",
      export: "Exporter",
      spinnerLoading: "Chargement...",
      createNewDomain: "Cr\u00E9er un nouveau domaine",
      walletName: "Nom du portefeuille",
      domainName: "Nom de domaine",
      domainNamePreview: "Aper\u00E7u",
      domainFormTitle: "Cr\u00E9er un nouveau domaine Luckey",
      invalidDomainName: "Libell\u00E9 de domaine invalide. 50 caract\u00E8res max. : lettres et chiffres, tiret uniquement entre caract\u00E8res (pas au d\u00E9but ni \u00E0 la fin), pas d'espaces",
      selectProduct: "S\u00E9lectionnez un type d\'abonnement",
      name: "Nom",
      lastname: "Nom de famille",
      createNewUser: "Cr\u00E9er un nouvel administrateur",
      selectRole: "S\u00E9lectionnez le r\u00F4le de l\'utilisateur",
      createUserForDomain: "Cr\u00E9er un nouvel utilisateur pour le domaine s\u00E9lectionn\u00E9",
      newUser: "Nouvel utilisateur",
      password: "Mot de passe",
      letUserChoosePassword: "Permettre \u00E0 l\'utilisateur de choisir son mot de passe : envoyer un lien de configuration par e-mail",
      domainCreateSuccess: "Domaine cr\u00E9\u00E9 avec succ\u00E8s",
      domainCreateUserAfterCreation: "Voulez-vous cr\u00E9er un utilisateur pour le nouveau domaine ?",
      domainCreationConfirm: "Voulez-vous cr\u00E9er le nouveau domaine ?",
      createDomain: "Cr\u00E9er le domaine",
      username: "Nom d\'utilisateur",
      domainExtendsConfirm: "Voulez-vous \u00E9tendre le domaine avec le produit s\u00E9lectionn\u00E9 ?",
      createNewInstaller: "Cr\u00E9er un nouvel installateur",
      createInstallerForDomain: "Cr\u00E9er un nouvel utilisateur installateur pour le domaine",
      deleteDomain: "Demander la suppression du domaine",
      active: "Actif",
      disabled: "D\u00E9sactiv\u00E9",
      minutes: "{{minutes}} minutes",
      selectSessionDurationPlaceholder: "Dur\u00E9e de la session",
      impersonateUserDescription: "Avant d\'impersonner l\'utilisateur dans le syst\u00E8me, nous vous informons que :",
      impersonateUserDescriptionOne: "Le d\u00E9but de la session et sa dur\u00E9e appara\u00EEtront dans les journaux du domaine",
      impersonateUserDescriptionTwo: "Chaque action effectu\u00E9e sera enregistr\u00E9e et appara\u00EEtront dans les journaux du syst\u00E8me",
      impersonateUserDescriptionThree: "Toute action effectu\u00E9e sur l\'implant aura un effet imm\u00E9diat et, dans certains cas, irr\u00E9versible",
      selectSessionDuration: "S\u00E9lectionnez la dur\u00E9e de la session de support",
      impersonateReadOnly: "Mode lecture seule",
      impersonateReadOnlyDescription: "Acc\u00E9dez au syst\u00E8me en mode lecture seule, vous pourrez consulter les donn\u00E9es sans les modifier",
      impersonateReadOnlyWarning: "Attention : La session de support et sa dur\u00E9e resteront visibles dans les journaux du syst\u00E8me",
      installationModeActive: "Actif",
      installationModeDisabled: "D\u00E9sactiv\u00E9",
      customerFormTitle: "Utilisateur final Luckey",
      customerContractFormTitle: 'Contrat de service',
      varFormTitle: "Revendeur \u00E0 valeur ajout\u00E9e (VAR)",
      varFormAdminSection: "Section administration",
      varFormTitleVar: "Infos de l\u2019entreprise",
      plantThemeFormTitle: "Th\u00E8me de site Luckey",
      customerName: "Nom de l\'utilisateur final",
      invalidCustomerName: "Nom de l\'utilisateur final invalide",
      createNewWallet: "Nouveau portefeuille",
      whatsNewTitle: "Les nouveautés de Luckey !",
      whatsNewSubtitle: "D\u00E9couvrez les derni\u00E8res actualit\u00E9s sur Luckey et Sofia, partie d\'ISEO",
      notes: "Notes suppl\u00E9mentaires",
      cardCode: "Code de recharge",
      recharge: "Recharger",
      rechargeWalletFormDescription: "Rechargez les cr\u00E9dits de ce portefeuille en entrant le code de recharge. La recharge sera effective imm\u00E9diatement",
      subscriptionName: "Nom de l\'abonnement",
      subscriptionFixedPrice: "Co\u00FBt d\'activation (cr\u00E9dits)",
      subscriptionBurnRate: "Co\u00FBt r\u00E9current (cr\u00E9dits)",
      subscriptionVisible: "Visible sur le march\u00E9",
      createNewSubscriptionDescription: "Cr\u00E9ez un nouvel abonnement dans le syst\u00E8me. L\'abonnement sera disponible pour tous les domaines",
      subscriptionLogicDescription: "Indiquez quels \u00E9l\u00E9ments du syst\u00E8me seront comptabilis\u00E9s pour d\u00E9terminer les contraintes du syst\u00E8me",
      FIXED: "Ne pas imposer de contraintes sur les \u00E9l\u00E9ments",
      COUNT_USERS_LOCKS: "Limiter le nombre d\'utilisateurs et de cadenas du domaine",
      COUNT_LOCKS: "Limiter uniquement le nombre de cadenas du domaine",
      COUNT_ELEMENTS: "Limiter la somme des cadenas et des utilisateurs du domaine",
      maxLocks: "Nombre maximum de cadenas intelligents",
      maxUsers: "Nombre maximum d\'utilisateurs",
      maxElements: "Nombre maximum d\'\u00E9l\u00E9ments (utilisateurs+cadenas)",
      subscriptionLogic: "Logique de limitation des \u00E9l\u00E9ments",
      selectLogic: "S\u00E9lectionner",
      subscriptionMaxLocksDescription: "Ins\u00E9rez le nombre maximum de cadenas pouvant \u00EAtre install\u00E9s avec cet abonnement",
      subscriptionMaxUsersDescription: "Ins\u00E9rez le nombre maximum d\'utilisateurs pouvant \u00EAtre activ\u00E9s avec cet abonnement",
      subscriptionMaxElementsDescription: "Ins\u00E9rez le nombre maximum d\'\u00E9l\u00E9ments avec cet abonnement",
      subscriptionResource: "Ressource",
      cardQuantity: "Nombre de cr\u00E9dits",
      cardQuantityDescription: "Indique le nombre de cr\u00E9dits qui seront recharg\u00E9s lors de l\'utilisation de la carte de recharge",
      cardVar: "Assigner la carte de recharge au VAR",
      cardWallet: "Assigner la carte de recharge \u00E0 un portefeuille sp\u00E9cifique",
      cardNotes: "Notes suppl\u00E9mentaires",
      createCardConfirm: "\u00CAtes-vous s\u00FBr de vouloir cr\u00E9er la carte de recharge ?",
      createVarOpportunityConfirm: "\u00CAtes-vous s\u00FBr de vouloir cr\u00E9er ce nouveau devis ?",
      createSubscrptionConfirm: "\u00CAtes-vous s\u00FBr de vouloir cr\u00E9er le nouvel abonnement ?",
      rechargeWalletConfirm: "Vous \u00EAtes sur le point de recharger le portefeuille de cet utilisateur final avec de nouveaux cr\u00E9dits, souhaitez-vous continuer ? L\u2019op\u00E9ration est irr\u00E9versible",
      createdAt: "Date de cr\u00E9ation",
      copiedSuccess: "Copi\u00E9 !",
      logout: "D\u00E9connexion",
      deleteCardConfirm: "\u00CAtes-vous s\u00FBr de vouloir supprimer cette carte de recharge ? L\u2019op\u00E9ration est irr\u00E9versible",
      enableCardConfirm: "\u00CAtes-vous s\u00FBr de vouloir activer cette carte de recharge ? Une fois activ\u00E9e, cette carte pourra \u00EAtre utilis\u00E9e. L\u2019op\u00E9ration est irr\u00E9versible",
      subscriptionTierSelectionTitle: "Abonnement principal",
      subscriptionTierSelectionDescription: "En s\u00E9lectionnant l\'abonnement principal, le nouvel add-on héritera automatiquement de la logique de comptage de l\'abonnement principal",
      selectTier: "S\u00E9lectionner l\'abonnement",
      createPluginSubscriptionConfirm: "\u00CAtes-vous s\u00FBr de vouloir cr\u00E9er ce nouvel abonnement d\'add-on\/service ?",
      createWalletSubscriptionConfirm: "\u00CAtes-vous s\u00FBr de vouloir associer cet abonnement au portefeuille s\u00E9lectionn\u00E9 ? L\'abonnement sera activ\u00E9 pour tous les sites g\u00E9r\u00E9s via ce portefeuille",
      deleteWalletSubscriptionConfirm: "\u00CAtes-vous s\u00FBr de vouloir supprimer cet abonnement du portefeuille s\u00E9lectionn\u00E9 ? L\'abonnement sera supprim\u00E9 de tous les sites g\u00E9r\u00E9s via ce portefeuille",
      editSubscriptionConfirm: "\u00CAtes-vous s\u00FBr de vouloir modifier l\'abonnement ?",
      walletSelectSubscriptionTitle: "Abonnement \u00E0 activer",
      walletSelectSubscriptionDescription: "S\u00E9lectionnez l\'abonnement \u00E0 activer sur ce portefeuille. N\u2019oubliez pas que l\'abonnement sera \u00E9galement activ\u00E9 sur tous les syst\u00E8mes g\u00E9r\u00E9s via ce portefeuille",
      createWalletPlantConfirm: "\u00CAtes-vous s\u00FBr de vouloir cr\u00E9er le nouveau domaine pour le portefeuille s\u00E9lectionn\u00E9 ?",
      enableEmailForPlant: "Activer le service e-mail",
      enableEmailForPlantDescription: "Activez l\u2019envoi d\u2019e-mails pour ce syst\u00E8me (e-mail d\u2019activation, notifications, etc.)",
      enableIrisRequiredForPlant: "Exiger le service 1ris",
      enableIrisRequiredForPlantDescription: "Si s\u00E9lectionn\u00E9, le domaine sera pr\u00EAt\u00E9 \u00E0 inclure le service 1ris",
      cardSubscriptionsLinked: "Abonnements associ\u00E9s",
      cardSubscriptionsLinkedDescription: "Associez plusieurs add-ons ou services \u00E0 cette carte de recharge pour les activer une fois la carte utilis\u00E9e",
      mainTierDescription: "Associez un abonnement principal \u00E0 cette carte de recharge pour l\u2019activer une fois utilis\u00E9e",
      cardMarketplacesLinked: "March\u00E9 pour l\u2019association des licences",
      cardMarketplacesLinkedDescription: "S\u00E9lectionnez un march\u00E9 pour choisir les abonnements \u00E0 associer \u00E0 cette carte de recharge",
      sku: "SKU",
      customerData: "Donn\u00E9es de l\'utilisateur final",
      customerVat: "TVA",
      customerFiscalCode: "Code fiscal",
      customerCountry: "Pays",
      customerAddress: "Adresse",
      customerCity: "Ville",
      customerEmail: "E-mail",
      customerPhone: "T\u00E9l\u00E9phone",
      customerCrmId: "ID COMPTE SFDC",
      customerMarketplace: "March\u00E9",
      customerCertifiedEmail: "PEC (e-mail certifi\u00E9)",
      customerKamEmail: "Key Account Manager",
      customerCluster: "Cluster",
      customerVar: "VAR",
      customerCompany: "Entreprise ISEO",
      customerPostalCode: "Code postal",
      customerPrincipalSubDivision: "Province, \u00C9tat, d\u00E9partement, etc.",
      iseoSalesOrderReference: "Commande de vente ISEO (ISEO \u2192 Client)",
      iseoSalesOrderDate: "Date de commande de vente ISEO",
      iseoPurchaseOrderReference: "Commande d\u2019achat ISEO (ISEO \u2192 Sofia)",
      iseoPurchaseOrderDate: "Date de commande d\u2019achat ISEO",
      sofiaSalesOrderReference: "Commande de vente Sofia (Sofia \u2192 ISEO)",
      sofiaSalesOrderDate: "Date de commande de vente Sofia",
      pickDate: "Choisir une date",
      crmSource: "Source d\u2019opportunit\u00E9 CRM",
      crmId: "Identifiant unique d\u2019opportunit\u00E9 CRM",
      sofiaProjectId: "Identifiant de r\u00E9f\u00E9rence du projet Sofia",
      crmLink: "URL vers l\u2019opportunit\u00E9 CRM",
      kamReference: "R\u00E9f\u00E9rence KAM",
      edit: "Modifier",
      editCardConfirm: "\u00CAtes-vous s\u00FBr de vouloir modifier la carte de recharge ?",
      editVarOpportunityConfirm: "\u00CAtes-vous s\u00FBr de vouloir modifier ce devis ?",
      insertEmailOTPLoginForm: "Entrez l\u2019e-mail de votre compte pour recevoir le code OTP et acc\u00E9der \u00E0 la plateforme",
      insertEmailOTPLoginFormDisclaimer: "Si l\u2019e-mail est autoris\u00E9, vous recevrez un code OTP pour acc\u00E9der",
      insertOTPOTPLoginForm: "Entrez le code OTP re\u00E7u sur l\u2019e-mail de votre compte",
      insertOTPOTPLoginFormDisclaimer: "Si vous n\u2019avez pas re\u00E7u le code apr\u00E8s 5 minutes, r\u00E9essayez",
      pickDateTo: "Choisissez la date jusqu\u2019\u00E0 :",
      pickDateFrom: "Choisissez la date \u00E0 partir de :",
      AUTOMATIC: "Activation automatique",
      MANUAL: "Activation manuelle",
      SEMI_AUTOMATIC: "Activation semi-automatique",
      AUTOMATIC_Description: "L\u2019extension peut \u00EAtre activ\u00E9e de mani\u00E8re ind\u00E9pendante depuis la boutique par l\u2019utilisateur. Les cr\u00E9dits d\u2019activation seront d\u00E9duits imm\u00E9diatement",
      MANUAL_Description: "Extension qui ne peut \u00EAtre activ\u00E9e qu\u2019apr\u00E8s une demande explicite de l\u2019utilisateur final. Les cr\u00E9dits seront d\u00E9duits manuellement apr\u00E8s approbation de la demande",
      SEMI_AUTOMATIC_Description: "Extension qui ne peut \u00EAtre activ\u00E9e qu\u2019apr\u00E8s une demande explicite de l\u2019utilisateur final. Les cr\u00E9dits d\u2019activation seront d\u00E9duits au moment de la demande",
      requestToQuote: "Devis demand\u00E9",
      requestToQuoteDescription: "Indiquez si l\u2019extension est soumise \u00E0 devis plut\u00F4t qu\u2019\u00E0 l\u2019utilisation directe des cr\u00E9dits",
      subscriptionCanBeDeactivated: "Peut \u00EAtre d\u00E9sactiv\u00E9 depuis le gestionnaire",
      subscriptionCanBeDeactivatedDescription: "Indiquez si le gestionnaire peut d\u00E9sactiver l\u2019abonnement depuis le Luckey Store",
      selectSegmentType: "S\u00E9lectionnez un segment",
      sofiaInvoiceNumber: "Num\u00E9ro de facture Sofia",
      sofiaInvoiceAmount: "Montant de la facture Sofia",
      sofiaInvoiceYear: "Ann\u00E9e de la facture Sofia",
      iseoInvoiceNumber: "Num\u00E9ro de facture ISEO",
      iseoInvoiceAmount: "Montant de la facture ISEO",
      iseoInvoiceYear: "Ann\u00E9e de la facture ISEO",
      freeOfCharge: "Gratuit",
      freeOfChargeReason: "Raison",
      currency: "Devise",
      sofiaInvoiceDate: "Date de facture",
      iseoInvoiceDate: "Date de facture",
      sofiaInvoiceRecipient: "Destinataire de la facture",
      iseoInvoiceRecipient: "Destinataire de la facture",
      serviceSupplementaryInvoice: "Facture suppl\u00E9mentaire de service",
      serviceSupplementaryInvoiceNumber: "Num\u00E9ro de facture",
      serviceSupplementaryInvoiceAmount: "Montant de la facture",
      serviceSupplementaryInvoiceDate: "Date de facture",
      serviceSupplementaryInvoiceRecipient: "Destinataire de la facture",
      iseoInvoiceIssuer: "\u00C9metteur de la facture",
      backdropClosing: "Voulez-vous vraiment fermer le formulaire sans enregistrer ?",
      roles: "R\u00F4les",
      selectBotType: "S\u00E9lectionner le type d'assistant",
      helperBot: 'Assistant technique',
      commercialBot: 'Assistant commercial',
      talkWithUs: 'Assistant IA',
      noBotTypeSelected: 'Aucun assistant sélectionné',
      invalidEmail: 'Veuillez saisir une adresse e-mail valide',
      customer: 'Utilisateur final standard',
      simplifiedCustomer: 'Utilisateur final semplifié',
    },
    activations: {
      cluster: 'Cluster',
      clusters: 'Clusters',
      getInfo: "(Obtenir plus d\u2019informations sur le processus)",
      createNewCustomer: "Cr\u00E9er un utilisateur final",
      createNewWallet: "Cr\u00E9er un portefeuille",
      createNewScratchcard: "Cr\u00E9er une carte de recharge",
      yearsString: "ann\u00E9es",
      monthsString: "mois",
      daysString: "jours",
      addNewActivationButton: "Ajouter une activation syst\u00E8me",
      home: "Accueil OD",
      activationRequests: "Activations syst\u00E8me",
      rechargeRequests: "Recharges de portefeuille",
      walletStatus: "Statut des commandes",
      noActivationsFoundTitle: "Aucune activation syst\u00E8me trouv\u00E9e",
      noActivationsFoundDescription: "Aucune activation syst\u00E8me dans le syst\u00E8me. Cr\u00E9ez-en de nouvelles pour commencer",
      selloutOrder: "Commande de vente",
      intragroupOrder: "Commande intragroupe",
      custref: "R\u00E9f. client",
      rejectedReason: "Raison du rejet",
      changeStatusToUnderReview: "Envoyer en r\u00E9vision",
      changeStatusToInvoiced: "Envoyer en factur\u00E9",
      changeStatusToCreated: "Envoyer en cr\u00E9\u00E9",
      changeStatusToRejected: "Rejeter la demande",
      changeStatusToProcessing: "Accepter la demande",
      changeStatusAdmin: "D\u00E9finir le statut (admin)",
      changeCustRef: "D\u00E9finir la r\u00E9f. client",
      search: "Rechercher...",
      resetFilters: "R\u00E9initialiser les filtres",
      statusSelection: "Tout statut",
      clusterSelection: "Tout cluster",
      statusDRAFT: "Brouillon",
      statusUNDER_REVIEW: "En r\u00E9vision",
      statusREJECTED: "Rejet\u00E9",
      statusPROCESSING: "En cours",
      statusCREATED: "Cr\u00E9\u00E9",
      statusINVOICED: "Factur\u00E9",
      statusACTIVE: "Actif",
      statusDELETED: "Supprim\u00E9",
      promote: "Supprimer",
      saveDraft: "Enregistrer en brouillon",
      customMarketplaceWarning: "L'utilisateur final n'est pas associ\u00E9 au march\u00E9 par d\u00E9faut. Vous devrez sp\u00E9cifier manuellement l'abonnement de base demand\u00E9 et les add-ons dans la section 'Notes'",
      subscriptionNotFoundError: "Abonnement non trouv\u00E9",
      deleteActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir supprimer cette activation syst\u00E8me ? L'op\u00E9ration est irr\u00E9versible",
      deleteActivationError: "Une erreur est survenue lors de la suppression de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      promoteActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir envoyer cette activation syst\u00E8me en r\u00E9vision ? La demande d'activation syst\u00E8me ne peut \u00EAtre modifi\u00E9e pendant la r\u00E9vision.",
      promoteActivationError: "Une erreur est survenue lors de l'envoi en r\u00E9vision de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      createdActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir passer cette activation syst\u00E8me au statut CR\u00C9\u00C9 ?",
      createdActivationError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      invoicedActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir marquer cette activation syst\u00E8me comme factur\u00E9e ?",
      invoicedActivationError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      editStatusActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir modifier le statut de cette activation syst\u00E8me ? L'op\u00E9ration est irr\u00E9versible",
      editStatusActivationError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      rejectActivationConfirm: "Sp\u00E9cifiez la raison du rejet de cette demande.",
      rejectActivationError: "Une erreur est survenue lors du rejet de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      processingActivationConfirm: "\u00CAtes-vous s\u00FBr de vouloir accepter cette activation syst\u00E8me ?",
      processingActivationError: "Une erreur est survenue lors de l'acceptation de l'activation syst\u00E8me. Veuillez r\u00E9essayer",
      newFileName: "Sp\u00E9cifiez le nom du fichier",
      newFileExtensionError: "Le fichier a une extension non prise en charge",
      newFileDuplicateNameError: "Ce nom a d\u00E9j\u00E0 \u00E9t\u00E9 utilis\u00E9 pour un autre fichier. Changez le nom et r\u00E9essayez.",
      editCustrefConfirm: "Sp\u00E9cifiez la r\u00E9f. client pour cette demande.",
      editCustrefError: "Une erreur est survenue lors de la mise \u00E0 jour de la r\u00E9f. client, veuillez r\u00E9essayer",
      editActivation: "Modifier l'activation syst\u00E8me",
      newActivation: "Ajouter une activation syst\u00E8me",
      viewActivation: "Voir l'activation syst\u00E8me",
      newActivationError: "Une erreur est survenue lors de la cr\u00E9ation de cette activation syst\u00E8me. Veuillez r\u00E9essayer",
      editActivationError: "Une erreur est survenue lors de la mise \u00E0 jour de cette activation syst\u00E8me. Veuillez r\u00E9essayer",
      customerSearch: "Rechercher parmi les utilisateurs finaux existants",
      customerSearchEnterName: "Rechercher par nom...",
      customerSearchNoMatch: "Aucun utilisateur final trouv\u00E9...",
      customerProceedWithSelected: "Utiliser l'utilisateur final s\u00E9lectionn\u00E9",
      customerProceedWithNew: "Cr\u00E9er un nouvel utilisateur final",
      customerConfirmData: "Confirmer les donn\u00E9es de l'utilisateur final",
      customerData: "Donn\u00E9es du client",
      varData: "Donn\u00E9es du VAR",
      selectCustomerOrVar: "S\u00E9lectionnez la cible pour cette demande (utilisateur final ou VAR)",
      varSfdcId: "ID COMPTE SFDC",
      varName: "Nom",
      varSearch: "Rechercher parmi les VAR existants",
      varSearchEnterName: "Rechercher par nom...",
      varSearchNoMatch: "Aucun VAR trouv\u00E9...",
      varCustomerSearch: "Rechercher parmi les utilisateurs finaux du VAR",
      varProceedWithSelected: "Utiliser le VAR s\u00E9lectionn\u00E9",
      customerFormTitle: "Utilisateur final Luckey",
      customerName: "Nom de l'utilisateur final",
      customerVat: "TVA",
      customerFiscalCode: "Code fiscal",
      customerCountry: "Pays",
      customerAddress: "Adresse",
      customerCity: "Ville",
      customerEmail: "E-mail",
      customerPhone: "T\u00E9l\u00E9phone",
      customerCrmId: "ID COMPTE SFDC",
      customerMarketplace: "March\u00E9",
      customerCertifiedEmail: "PEC (e-mail certifi\u00E9)",
      customerKamEmail: "Key Account Manager",
      customerCluster: "Cluster",
      customerVar: "VAR",
      customerCompany: "Entreprise ISEO",
      customerPostalCode: "Code postal",
      customerPrincipalSubDivision: "Province, \u00C9tat, d\u00E9partement, etc.",
      exportActivationsCSV: "Exporter en CSV",
      salesAndOrdersData: "Ventes \u0026 Commandes",
      basicData: "Informations sur le site",
      formEnterAnswer: "Votre r\u00E9ponse",
      formEnterAnswerGT0: "Nombre sup\u00E9rieur \u00E0 z\u00E9ro",
      formEnterAnswerFrom0To600: "Nombre entre 0 et 600",
      formEnterAnswerOwnerEmail: "E-mail du propri\u00E9taire",
      formEnterAnswerKamEmail: "E-mail du Key Account Manager",
      formEnterAnswerPmEmail: "E-mail du PM",
      formEnterAnswerSystemEngineerEmail: "E-mail de l'ing\u00E9nieur syst\u00E8me",
      optId: "ID opportunit\u00E9 (SFDC)",
      salesOrderConfirmationNumber: "Num\u00E9ro de confirmation de commande de vente (sell-out)",
      salesOrderConfirmationNumber_desc: "",
      selloutFiles: "Commande de vente PDF (hardware + software + services professionnels)",
      selloutFiles_desc: "N\u00E9cessaire pour suivre correctement les revenus de Blossom.",
      selloutFiles_desc2: "Limite de fichiers : 5  ~  Taille maximale de chaque fichier : 10MB  ~  Extensions autoris\u00E9es : ",
      selloutFilesAdd: "T\u00E9l\u00E9charger le fichier",
      selloutFilesDownload: "T\u00E9l\u00E9charger",
      selloutFilesReplace: "Remplacer",
      quotationToolFile: "Outil de devis (non obligatoire)",
      quotationToolFile_desc: "T\u00E9l\u00E9chargez le fichier de l'outil de devis utilis\u00E9 pour cette demande.",
      quotationToolFile_desc2: "Limite de fichiers : 1  ~  Taille maximale de chaque fichier : 10MB",
      purchaseOrderNumberSofia: "Num\u00E9ro de commande d'achat \u00E0 Sofia",
      baselineSubscription: "Abonnement de base Luckey",
      baselineSubscription_BASIC: "Luckey Basique",
      baselineSubscription_ENTERPRISE: "Luckey Enterprise (Standard)",
      baselineSubscription_ENGINE: "Luckey Engine",
      baselineSubscription_undefined: "Utiliser un abonnement personnalis\u00E9",
      subscriptionData: "Infos abonnement",
      noSubscriptionFound: "Aucun abonnement trouv\u00E9 pour le moment.",
      noSubscriptionFoundPleaseCheck: " Veuillez v\u00E9rifier les champs ",
      noSubscriptionFoundDescription: "La liste des abonnements est vide. Si vous avez appliqu\u00E9 un filtre de recherche, essayez de le r\u00E9initialiser et r\u00E9essayez",
      selectedSubscription: "Abonnement s\u00E9lectionn\u00E9 : ",
      plantName: "Nom du site",
      plantName_desc: "En minuscules, sans espaces et, si n\u00E9cessaire, s\u00E9par\u00E9 par des tirets - ex. nom-site-exemple",
      keyAccountManager: "Key Account Manager",
      keyAccountManager_desc: "Adresse e-mail du Key Account Manager",
      systemManagerEmails: "E-mails des administrateurs du syst\u00E8me (un ou plusieurs)",
      systemManagerEmails_desc: "Adresse e-mail de la personne charg\u00E9e de g\u00E9rer les permissions d'acc\u00E8s des utilisateurs sur la plateforme web",
      installerEmail: "E-mail de l'installateur (non obligatoire)",
      installerEmail_desc: "",
      pmEmail: "E-mail du PM (non obligatoire)",
      pmEmail_desc: "Doit appartenir \u00E0 @sofialocks.com ou @iseo.com",
      systemEngineerEmail: "E-mail de l'ing\u00E9nieur syst\u00E8me (non obligatoire)",
      systemEngineerEmail_desc: "Doit appartenir \u00E0 @sofialocks.com ou @iseo.com",
      numberOfElements: "Nombre d'\u00E9l\u00E9ments \u00E0 g\u00E9rer",
      numberOfElements_desc: "Les \u00E9l\u00E9ments sont la somme des : utilisateurs, cadenas et toutes les invitations actives",
      V364orF9000: "Cadenas V364\/1RIS ou cylindres F9000 ?",
      V364orF9000_desc: "Y a-t-il des cadenas V364\/1RIS ou des cylindres F9000 dans le syst\u00E8me ? Si oui, l'add-on associ\u00E9 sera ajout\u00E9 automatiquement",
      addons: "Add-ons \u0026 Plug-ins",
      addons_desc: "S\u00E9lectionnez les add-ons \u00E0 ajouter \u00E0 l'abonnement de base",
      credits: "Nombre de cr\u00E9dits",
      credits_desc: "Cr\u00E9dits vendus avec cette activation syst\u00E8me",
      expectedEnd: "Selon votre s\u00E9lection, vos cr\u00E9dits s'\u00E9puiseront dans : ",
      finalData: "Autres informations",
      notes: "Notes",
      notes_desc: "\u00C9crivez ici toute note suppl\u00E9mentaire concernant cette demande",
      notifications: "Notifications",
      notifications_desc: "Personnes \u00E0 notifier pour les \u00E9v\u00E9nements ; par d\u00E9faut, le propri\u00E9taire de la demande et le Key Account Manager associ\u00E9 seront notifi\u00E9s",
      editBaselineSubscriptionWarning: "\u00CAtes-vous s\u00FBr de vouloir changer l'abonnement de base ? Cela r\u00E9initialisera les add-ons s\u00E9lectionn\u00E9s dans le formulaire.",
      editBaselineSubscriptionError: "Une erreur est survenue, veuillez r\u00E9essayer",
      editNumberOfElementsWarning: "\u00CAtes-vous s\u00FBr de vouloir changer le nombre d'\u00E9l\u00E9ments ? Cela r\u00E9initialisera les add-ons disponibles dans le formulaire.",
      editNumberOfElementsError: "Une erreur est survenue, veuillez r\u00E9essayer",
      customerMarketplaceError: "L'utilisateur final s\u00E9lectionn\u00E9 n'est associ\u00E9 \u00E0 aucun march\u00E9. Veuillez contacter le support pour r\u00E9soudre le probl\u00E8me.",
      customerClusterError: "L'utilisateur final s\u00E9lectionn\u00E9 n'est associ\u00E9 \u00E0 aucun cluster. Veuillez contacter le support pour r\u00E9soudre le probl\u00E8me.",
      invoiceData: "Facture",
      invoiceFile: "Facture PDF *",
      invoiceFile_desc: "T\u00E9l\u00E9chargez la facture en PDF.",
      invoiceFile_desc2: "Limite de fichiers : 1  ~  Taille maximale de chaque fichier : 10MB",
      invoiceNumber: "Num\u00E9ro et date de facture de vente (XXXXXX - JJ\/MM\/AAAA)",
      invoiceNumberPlaceholder: "XXXXXX - JJ\/MM\/AAAA",
      setInvoiceData: "T\u00E9l\u00E9charger la facture",
      dataMissingCreated: "Sp\u00E9cifiez le num\u00E9ro de facture et le PDF pour continuer"
    },
    recharges: {
      recalculate: "R\u00E9calculer",
      restartRechargeJob: 'R\u00E9initialiser le calcul',
      restartRechargeJobConfirm: 'Voulez-vous vraiment r\u00E9initialiser le calcul des recharges?',
      restartRechargeJobSuccess: 'Calcul des recharges r\u00E9initialis\u00E9 avec succ\u00E8s',
      restartRechargeJobError: 'Une erreur est survenue lors de la r\u00E9initialisation du calcul des recharges. Veuillez r\u00E9essayer',
      addNewRechargeButton: "Ajouter une recharge de portefeuille",
      noRechargesFoundTitle: "Aucune recharge trouv\u00E9e",
      noRechargesFoundDescription: "Il n'y a aucune recharge de portefeuille dans le syst\u00E8me. Cr\u00E9ez-en de nouvelles pour commencer",
      customerAndWallet: "Utilisateur final et portefeuille",
      seeCustomer: "Infos",
      seeCustomerDetails: "Voir les d\u00E9tails de l'utilisateur final",
      selloutOrder: "Commande de vente",
      intragroupOrder: "Commande intragroupe",
      custref: "R\u00E9f. client",
      mode: "Type de renouvellement de contrat :",
      creditsSuggested: "Cr\u00E9dits sugg\u00E9r\u00E9s",
      creditsConfirmed: "Cr\u00E9dits confirm\u00E9s",
      rejectedReason: "Raison du rejet",
      deletedReason: "Raison de la suppression",
      createdAt: "Cr\u00E9\u00E9 le",
      updatedAt: "Mis \u00E0 jour le",
      customerSearch: "Rechercher parmi les utilisateurs finaux existants",
      customerSearchEnterName: "Rechercher par nom...",
      customerSearchNoMatch: "Aucun utilisateur final trouv\u00E9...",
      varSearch: "Rechercher parmi les VAR existants",
      varSearchEnterName: "Rechercher par nom...",
      varSearchNoMatch: "Aucun VAR trouv\u00E9...",
      varCustomerSearch: "Rechercher parmi les utilisateurs finaux du VAR",
      plantSearch: "S\u00E9lectionnez le site souhait\u00E9",
      plantSearchEnterName: "S\u00E9lectionner un site",
      plantSearchNoMatch: "Aucun site trouv\u00E9...",
      plantProceedWithSelected: "Utiliser le site\/portefeuille s\u00E9lectionn\u00E9",
      dataMissingTakenCharge: "Sp\u00E9cifiez les cr\u00E9dits confirm\u00E9s et la commande de vente pour continuer",
      dataMissingScratchcardCreated: "Sp\u00E9cifiez le num\u00E9ro de facture et le PDF pour continuer",
      changeStatusToSelloutOrderGenerated: "Envoyer en r\u00E9vision",
      changeStatusToInvoiced: "Envoyer en factur\u00E9",
      changeStatusToCreated: "Envoyer en cr\u00E9\u00E9",
      changeStatusToRejected: "Rejeter la demande",
      changeStatusToScratchcardCreated: "Recharge cr\u00E9\u00E9e",
      changeStatusToWalletRecharged: "Portefeuille recharg\u00E9",
      changeStatusAdmin: "D\u00E9finir le statut (admin)",
      createCard: "Cr\u00E9er une carte de recharge",
      changeCustRef: "D\u00E9finir la r\u00E9f. client",
      search: "Rechercher...",
      resetFilters: "R\u00E9initialiser les filtres",
      statusSelection: "Tout statut",
      clusterSelection: "Tout cluster",
      statusTO_BE_MANAGED: "\u00C0 gérer",
      statusTAKEN_CHARGE: "En cours de traitement",
      statusREQUEST_TO_DELETE: "Demande de suppression",
      statusSELLOUT_ORDER_GENERATED: "En r\u00E9vision",
      statusSCRATCHCARD_CREATED: "Recharge cr\u00E9\u00E9e",
      statusWALLET_RECHARGED: "Recharg\u00E9",
      statusREJECTED: "Rejet\u00E9",
      statusDELETED: "Supprim\u00E9",
      statusINVOICED: "Factur\u00E9",
      promote: "Supprimer",
      saveRequest: "Enregistrer la demande",
      createRequest: "Cr\u00E9er une recharge de portefeuille",
      takeCharge: "Prendre en charge",
      AUTO_RENEWABLE: "Renouvelable automatiquement",
      NOT_AUTO_RENEWABLE: "Non renouvelable automatiquement",
      deleteRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir supprimer cette demande ? Veuillez sp\u00E9cifier la raison. L'op\u00E9ration est irr\u00E9versible",
      deleteAdminRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir supprimer d\u00E9finitivement cette demande ? L'op\u00E9ration est irr\u00E9versible",
      deleteRechargeError: "Une erreur est survenue lors de la suppression de la demande. Veuillez r\u00E9essayer",
      takechargeRechargeConfirm: "Veuillez sp\u00E9cifier le type de renouvellement pour traiter cette demande",
      takechargeRechargeDirectConfirm: "\u00CAtes-vous s\u00FBr de vouloir prendre en charge cette demande ?",
      takechargeRechargeError: "Une erreur est survenue lors de la prise en charge de la demande. Veuillez r\u00E9essayer",
      promoteRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir envoyer cette demande en r\u00E9vision ? La demande ne pourra pas \u00EAtre modifi\u00E9e pendant la r\u00E9vision.",
      promoteRechargeError: "Une erreur est survenue lors de l'envoi en r\u00E9vision de la demande. Veuillez r\u00E9essayer",
      createdRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir passer cette demande au statut CR\u00C9\u00C9 ?",
      createdRechargeError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de la demande. Veuillez r\u00E9essayer",
      invoicedRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir marquer cette demande comme factur\u00E9e ?",
      invoicedRechargeError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de la demande. Veuillez r\u00E9essayer",
      editStatusRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir modifier le statut de cette demande ? L'op\u00E9ration est irr\u00E9versible",
      editStatusRechargeError: "Une erreur est survenue lors de la mise \u00E0 jour du statut de la demande. Veuillez r\u00E9essayer",
      rejectRechargeConfirm: "Sp\u00E9cifiez la raison du rejet de cette demande.",
      rejectRechargeError: "Une erreur est survenue lors du rejet de la demande. Veuillez r\u00E9essayer",
      scratchcardCreatedRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir accepter cette demande et confirmer que la carte de recharge a \u00E9t\u00E9 cr\u00E9\u00E9e ?",
      scratchcardCreatedRechargeError: "Une erreur est survenue lors de l'acceptation de la demande. Veuillez r\u00E9essayer",
      walletRechargedRechargeConfirm: "\u00CAtes-vous s\u00FBr de vouloir marquer cette demande comme termin\u00E9e et confirmer que le portefeuille a \u00E9t\u00E9 recharg\u00E9 ?",
      walletRechargedRechargeError: "Une erreur est survenue lors de la modification du statut de la demande. Veuillez r\u00E9essayer",
      newFileName: "Sp\u00E9cifiez le nom du fichier",
      newFileExtensionError: "Le fichier a une extension non prise en charge",
      newFileDuplicateNameError: "Ce nom a d\u00E9j\u00E0 \u00E9t\u00E9 utilis\u00E9 pour un autre fichier. Changez le nom et r\u00E9essayez.",
      editCustrefConfirm: "Sp\u00E9cifiez la r\u00E9f. client pour cette demande.",
      editCustrefError: "Une erreur est survenue lors de la mise \u00E0 jour de la r\u00E9f. client, veuillez r\u00E9essayer",
      editRecharge: "Modifier la recharge de portefeuille",
      newRecharge: "Ajouter une recharge de portefeuille",
      viewRecharge: "Voir la recharge de portefeuille",
      newRechargeError: "Une erreur est survenue lors de la cr\u00E9ation de cette demande. Veuillez r\u00E9essayer",
      editRechargeError: "Une erreur est survenue lors de la mise \u00E0 jour de cette demande. Veuillez r\u00E9essayer",
      exportRechargesCSV: "Exporter en CSV",
      basicData: "Param\u00E8tres de la recharge de portefeuille",
      ordersData: "Commandes",
      invoiceData: "Facture",
      formEnterAnswer: "Votre r\u00E9ponse",
      formEnterAnswerGT0: "Nombre sup\u00E9rieur \u00E0 z\u00E9ro",
      sfdcId: "ID opportunit\u00E9 (SFDC)",
      salesOrderConfirmationNumber: "Num\u00E9ro de confirmation de commande de vente (sell-out)",
      salesOrderConfirmationNumber_desc: "",
      selloutFiles: "Commande de vente PDF (hardware + software + services professionnels)",
      selloutFiles_desc: "N\u00E9cessaire pour suivre correctement les revenus de Blossom.",
      selloutFiles_desc2: "Limite de fichiers : 5  ~  Taille maximale de chaque fichier : 10MB  ~  Extensions autoris\u00E9es : ",
      selloutFilesAdd: "T\u00E9l\u00E9charger le fichier",
      selloutFilesDownload: "T\u00E9l\u00E9charger",
      selloutFilesReplace: "Remplacer",
      invoiceFile: "Facture PDF *",
      invoiceFile_desc: "T\u00E9l\u00E9chargez la facture en PDF.",
      invoiceFile_desc2: "Limite de fichiers : 1  ~  Taille maximale de chaque fichier : 10MB",
      invoiceNumber: "Num\u00E9ro de facture de vente (pour l'utilisateur final) *",
      purchaseOrderNumberSofia: "Num\u00E9ro de commande d'achat \u00E0 Sofia",
      orderContactEmail: "E-mail de contact de la commande"
    },
    vars: {
      varCategoryType: 'Type',
      varCategoryType_VAR: 'VAR',
      varCategoryType_DEALER: 'Dealer',
      partnerLevel: 'Niveau de partenaire',
      runningQuotations: 'Quotations en cours',
      activeCustomers: 'Clients actifs',
      activeSystems: 'Systèmes actifs',
      monthlyCreditsBurnRate: 'Consommation mensuelle de crédits',
      varHome: 'Home',
      candidatePartnerStepsAway: 'Vous devez signer le contrat pour devenir partenaire enregistré',
      candidatePartnerStepsAwayDescription: 'Signer et envoyer l\'accord VAR pour devenir partenaire enregistré',
      registeredPartnerStepsAway: 'Vous êtes à un pas de devenir un partenaire enregistré',
      registeredPartnerStepsAwayDescription: 'Signer et envoyer l\'accord VAR pour devenir partenaire enregistré',
      preferredPartner: 'Vous êtes classé comme partenaire préféré !',
      preferredPartnerDescription: 'Vous êtes maintenant visible sur notre site web comme partenaire préféré',
      preferredPartnerStepsAway: 'Vous êtes {{steps}} pas de devenir un partenaire préféré',
      preferredPartnerStepsAwayDescription: 'Pour être visible sur notre site web comme partenaire préféré, vous devez compléter les étapes restantes',
      partnerLevelContractSigned: 'Accord signé',
      partnerLevelRebateLetterSigned: 'Lettre de rebate signée',
      partnerLevelTrainingCompleted: 'Formation terminée',
      partnerLevelDemoKitPurchased: 'Kit de démonstration acheté',
      partnerLevelQuotationRequested: 'Demande de cotation',
      partnerLevelOneActiveCustomer: 'Un client actif',
      varDocumentHistoryRebateLetter: 'Historique de fichiers',
      varDocumentHistoryAgreement: 'Historique de fichiers',
      varDocumentHistoryDate: 'Date de substitution',
      syncsfdcidVarOpportunitySuccess: 'Demande prise en charge. Veuillez vérifier l\'opportunité correspondante dans Salesforce',
      varLogo: "Logo",
      setTrainingDate: "Définir la date de formation",
      missingLastTrainingDateForCertificate: "Ce VAR n'a pas de date de formation définie. Veuillez définir une date de formation et réessayer de générer le certificat",
      expiredLastTrainingDateForCertificate: 'La formation de ce VAR a expiré. Veuillez mettre à jour la date de formation et réessayer de générer le certificat',
      varLastTrainingData: "Derni\u00E8re date de formation",
      varShortDescription: "Br\u00E8ve description",
      varLastTrainingDataExpirationDate: "Fecha de caducidad de la capacitación",
      rebateLetterFile: 'Lettre de rebate',
      varRebateLetterFileExpirationDate: 'Date de caducité de la lettre de rebate',
      varAgreementFileExpirationDate: 'Date de caducité de l\'accord',
      varDemoKitPurchaseDate: 'Date d\'achat du kit de démonstration',
      varDemoKitOrderNumber: 'Numéro de commande du kit de démonstration',
      varCity: "Ville",
      varCountry: "Pays",
      varWebsite: "Site web",
      varVisibleOnSofiaWebsite: "Visible sur la page des partenaires du site de Sofia",
      downloadCertificate: "T\u00E9l\u00E9charger le certificat",
      opportunityChangeOwnerMessage: "Veuillez spécifier le propriétaire de ce devis",
      noOpportunityHistoryFound: "Aucun historique de devis trouvé",
      noOpportunityHistoryFoundDescription: "Ce devis n'a aucun enregistrement historique",
      customers: "Clients",
      varsManagement: "VARs",
      varSettings: "Paramètres",
      varInfoPage: "Formation & Ressources",
      varUsersPage: "Utilisateurs",
      vars: "VAR",
      plantThemes: "Thèmes de site",
      editVarPersonalConfirm: "Vous êtes sur le point de modifier les informations de votre entreprise. Êtes-vous sûr de vouloir continuer ?",
      editVarConfirm: "Vous êtes sur le point de modifier les données du VAR. Êtes-vous sûr de vouloir continuer ?",
      editVar: "Modifier le VAR",
      newVar: "Nouveau VAR",
      varCreationConfirm: "Voulez-vous créer le nouveau VAR ?",
      createVar: "Créer le VAR",
      noVarFindTitle: "Aucun VAR trouvé",
      noVarFindDescription: "La liste des VAR est vide. Si vous avez appliqué un filtre de recherche, essayez de le réinitialiser et réessayez",
      noPlantThemeFindTitle: "Aucun thème de site trouvé",
      noPlantThemeFindDescription: "La liste des thèmes de site est vide. Si vous avez appliqué un filtre de recherche, essayez de le réinitialiser et réessayez",
      clusterSelection: "Tout cluster",
      varSelection: "Tout VAR",
      varName: "Nom",
      varAddress: "Adresse",
      varEmail: "E-mail de contact principal",
      varPhone: "Téléphone",
      varCluster: "Cluster",
      varVat: "TVA",
      varTechContact: "Contact technique",
      varCommercialContact: "Contact commercial",
      varNameTech: "Nom du contact technique",
      varEmailTech: "E-mail du contact technique",
      varPhoneTech: "Téléphone du contact technique",
      varNameComm: "Nom du contact commercial",
      varEmailComm: "E-mail du contact commercial",
      varPhoneComm: "Téléphone du contact commercial",
      varSfdcid: "ID COMPTE SFDC",
      varSupportEmail: "E-mail de support",
      varSupportHours: "Horaires de support",
      varCompanyName: "Nom de l'entreprise",
      varCustomers: "Utilisateurs finaux du VAR",
      varUsers: "Utilisateurs du VAR",
      varOpportunities: "Devis du VAR",
      editPlantThemeConfirm: "Vous êtes sur le point de modifier les données du thème du site. Êtes-vous sûr de vouloir continuer ?",
      editPlantTheme: "Modifier le thème du site",
      newPlantTheme: "Nouveau thème de site",
      plantThemeCreationConfirm: "Voulez-vous créer le nouveau thème de site ?",
      editVarPersonal: "Modifier les informations de l'entreprise",
      plantThemeName: "Nom",
      plantThemeColour: "Couleur *",
      plantThemeColourDescription: "Couleur du thème",
      plantThemeLogo: "Logo",
      plantThemeDefault: "Utiliser comme thème par défaut",
      logoFile: "Image du logo *",
      logoFile_desc: "Extensions de fichier autorisées : ",
      logoFileAdd: "Télécharger le fichier",
      logoFileDownload: "Télécharger",
      logoFileReplace: "Remplacer",
      deletePlantThemeConfirm: "Voulez-vous vraiment supprimer ce thème de site ? L'opération est irréversible",
      plantThemeSearchEnterName: "Sélectionnez le thème",
      plantThemeSearch: "Sélectionnez le thème souhaité",
      domainThemeTitle: "Thème de domaine personnalisé",
      domainThemeDescription: "Définissez votre thème personnalisé sur ce domaine",
      plantThemeModifySuccess: "Thème du site modifié et mis à jour",
      cannotDeleteAssociatedTheme: "Impossible de supprimer un thème associé à un site.",
      plantThemeAssociatedPlants: "Sites associés à ce thème",
      newVarUser: "Nouvel utilisateur VAR",
      varUserCreationConfirm: "Voulez-vous créer le nouvel utilisateur VAR ?",
      createVarUser: "Créer l'utilisateur VAR",
      varUserFormTitle: "Utilisateur VAR",
      createNewVarUser: "Créer un nouvel utilisateur VAR",
      noVarUserFindTitle: "Aucun utilisateur VAR trouvé",
      noVarUserFindDescription: "La liste des utilisateurs VAR est vide",
      deleteVarUserConfirm: "Voulez-vous vraiment supprimer cet utilisateur VAR ? L'opération est irréversible",
      deleteVarOpportunityConfirm: "Voulez-vous vraiment supprimer ce devis ? L'opération est irréversible",
      rejectVarOpportunityConfirm: "Voulez-vous vraiment rejeter ce devis ? L'opération est irréversible",
      approveVarOpportunityConfirm: "Voulez-vous vraiment approuver ce devis ? L'opération est irréversible",
      syncsfdcidVarOpportunityConfirm: "Voulez-vous vraiment associer un ID SFDC à ce devis ? L'opération est irréversible",
      upgradeVarOpportunityConfirm: "Voulez-vous vraiment envoyer ce devis en révision ? L'opération est irréversible",
      winVarOpportunityConfirm: "Voulez-vous vraiment marquer ce devis comme GAGNÉ ? L'opération est irréversible",
      lostVarOpportunityConfirm: "Voulez-vous vraiment marquer ce devis comme PERDU ? L'opération est irréversible",
      deleteUserConfirm: "Voulez-vous vraiment supprimer cet utilisateur ? L'opération est irréversible",
      varUserUsername: "Nom d'utilisateur",
      varUserFirstname: "Prénom",
      varUserLastname: "Nom de famille",
      varUserEmail: "E-mail",
      varUsersList: "Utilisateurs",
      newFileExtensionError: "Le fichier a une extension non prise en charge",
      agreementFile: "Accord",
      opportunities: "Devis",
      opportunityManagement: "Infos devis",
      opportunityID: "ID",
      opportunityOpty: "ID OPTY SFDC",
      opportunityVar: "VAR",
      opportunityCustomer: "Utilisateur final",
      opportunityOwner: "Propriétaire du devis",
      opportunityName: "Nom du devis",
      opportunityValue: "Valeur",
      opportunityStatus: "Statut",
      opportunityActions: "Actions",
      opportunityDescription: "Description",
      opportunityNotes: "Notes",
      opportunityCrm: "CRM",
      noOpportunityFindTitle: "Aucun devis trouvé",
      noOpportunityFindDescription: "La liste des devis est vide",
      opportunityStatus_DRAFT: "Brouillon",
      opportunityStatus_ON_APPROVAL: "En révision",
      opportunityStatus_APPROVED: "Approuvé",
      opportunityStatus_CANCELLED: "Annulé",
      opportunityStatus_REJECTED: "Rejeté",
      opportunityStatus_WON: "Gagné",
      opportunityStatus_LOST: "Perdu",
      opportunityFiles: "Fichiers joints",
      newOpportunity: "Nouveau devis",
      editOpportunity: "Modifier le devis",
      opportunitySyncSFDC: "Synchroniser avec SFDC",
      exportOpportunities: "Exporter en CSV",
      upgradeOpportunity: "Envoyer en révision",
      approveOpportunity: "Approuver",
      rejectOpportunity: "Rejeter",
      wonOpportunity: "Marquer comme GAGNÉ",
      lostOpportunity: "Marquer comme PERDU",
      CREATED: "Devis créé",
      VAR_USER_UPDATED: "Utilisateur VAR assigné au devis mis à jour",
      DESCRIPTION_UPDATED: "Description du devis mise à jour",
      NAME_UPDATED: "Nom du devis mis à jour",
      VALUE_UPDATED: "Valeur du devis mise à jour",
      CURRENCY_UPDATED: "Devise du devis mise à jour",
      OPTY_ID_UPDATED: "ID OPTY du devis mis à jour",
      ISEO_CRM_ID_UPDATED: "ID SFDC du devis mis à jour",
      DOCUMENTS_UPDATED: "Documents du devis mis à jour",
      STATUS_ON_APPROVAL: "Devis envoyé en révision",
      STATUS_APPROVED: "Devis approuvé",
      STATUS_WON: "Devis marqué comme gagné",
      STATUS_LOST: "Devis marqué comme perdu",
      STATUS_DRAFT: "Devis marqué comme brouillon",
      STATUS_CANCELLED: "Devis marqué comme annulé",
      CANCELLED: "Devis annulé",
      STATUS_REJECTED: "Devis marqué comme rejeté",
      showOpportunityHistory: "Afficher l'historique",
      opportunityHistory: "Historique du devis"
    },
    save: "Enregistrer",
    languages: {
      it: "Italien",
      en: "Anglais",
      de: "Allemand",
      fr: "Français",
      es: "Espagnol",
      nl: "Néerlandais",
      ITALIAN: "Italien",
      ENGLISH: "Anglais",
      GERMAN: "Allemand",
      FRENCH: "Français",
      SPANISH: "Espagnol",
      DUTCH: "Néerlandais",
      menuHeading: "Choisissez une langue"
    },
    productInfo: {
      software: "Logiciel",
      salesMaterial: "Matériel de vente",
      hardware: "Matériel",
      marketingMaterial: "Matériel marketing"
    },
    users: {
      usersManagement: "Gestion des utilisateurs",
      users: "Utilisateurs",
      noUserFindTitle: "Aucun utilisateur trouvé",
      noUserFindDescription: "La liste des utilisateurs est vide. Essayez de réinitialiser vos filtres de recherche s'il y en a",
      search: "Rechercher...",
      roleSelection: "Rôle",
      clusterSelection: "Cluster",
      varSelection: "VAR",
      newUser: "Ajouter",
      userFirstname: "Prénom",
      userLastname: "Nom de famille",
      userEmail: "E-mail",
      userFormTitle: "Données de l'utilisateur",
      editUserForm: "Modifier l'utilisateur",
      newUserForm: "Créer un utilisateur"
    },
    permissions: {
      CSV_IMPORT: 'Gérer les importations de systèmes Master Key',
      CREATE_REQUEST: 'Créer des demandes',
      MANAGE_REQUEST: 'Gérer des demandes',
      EXPORT_REQUESTS: 'Exporter des demandes',
      MKS: 'Gestion des systèmes Master Key',
      SEARCH_BY_DOMAIN: 'Rechercher par domaine',
      SELLOUT_GENERATED: 'Sellout généré',
      INVOICED: 'Facturé',
      MARK_UNDER_REVIEW: 'Marquer l\'entité comme En révision',
      NAVIGATION: "Visibilité du menu",
      CLUSTER: "Cluster",
      VAR: "VAR",
      CUSTOMER: "Utilisateurs finaux",
      OPPORTUNITY: "Devis",
      WALLET: "Portefeuilles d'utilisateurs finaux",
      DOMAIN: "Systèmes d'utilisateurs finaux",
      GATEWAYS: "Gateway",
      CARD: "Cartes de recharge",
      PLANT_ACTIVATION: "Activations système",
      RECHARGE_REQUEST: "Recharges système",
      ACTIVATION_REQUEST: "Demandes d'activation",
      EXPORT: "Exporter des entités",
      CREATE: "Créer une nouvelle entité",
      UPDATE: "Mettre à jour une entité",
      MARK_LOST: "Marquer l'entité comme Perdue",
      MARK_WON: "Marquer l'entité comme Gagnée",
      CANCEL: "Marquer l'entité comme Annulée",
      CANCEL_DRAFT: "Marquer l'entité comme Annulée lorsqu'elle est en brouillon",
      CANCEL_ON_APPROVAL: "Marquer l'entité comme Annulée lorsqu'elle est en révision",
      CANCEL_APPROVED: "Marquer l'entité comme Annulée lorsqu'elle est approuvée",
      MARK_TO_BE_APPROVED: "Marquer l'entité pour approbation",
      RECHARGE: "Recharger",
      SUBSCRIPTION_UPDATE: "Mettre à jour les abonnements",
      DELETE_REQUEST: "Envoyer une demande de suppression",
      CREATION_REQUEST: "Envoyer une demande de création de nouvelle entité",
      MANAGER_CREATE: "Créer des administrateurs",
      MANAGER_UPDATE: "Mettre à jour des administrateurs",
      INSTALLER_CREATE: "Créer des installateurs",
      INSTALLER_UPDATE: "Mettre à jour des installateurs",
      IMPERSONATE_WRITE: "Impersonner les administrateurs",
      IMPERSONATE_SUPPORT: "Impersonner le compte support",
      ADDITIONAL_INFO_UPDATE: "Modifier les informations supplémentaires",
      CUSTOMERS: "Utilisateurs finaux",
      PLANT_ACTIVATIONS: "Activations système",
      RECHARGE_REQUESTS: "Recharges système",
      ACTIVATION_REQUESTS: "Demandes d'activation",
      CARDS: "Cartes de recharge",
      VAR_USERS: "Utilisateurs VAR",
      VAR_SETTINGS: "Paramètres VAR",
      OPPORTUNITIES: "Devis",
      PRODUCTINFO: "Informations produit",
      USER_READ: "Voir les utilisateurs",
      USER_UPDATE: "Mettre à jour un utilisateur",
      USER_CREATE: "Créer un nouvel utilisateur",
      PLANT_THEME: "Changer le thème du domaine",
      READ: "Lire les valeurs de l'entité",
      ORDERS_STATUS: "Statut des commandes",
      FILTER: "Filtrer les entités",
      VAR_MANAGEMENT: "Gestion des VAR",
      MARKETPLACES: "Marchés",
      DOMAINS: "Systèmes d'utilisateurs finaux",
      PRICELIST: "Liste de prix",
      SALESINFO: "Infos de vente",
      PLATFORM_USERS: "Gestion des utilisateurs",
      APPROVE: "Marquer l'entité comme Approuvée",
      REJECT: "Marquer l'entité comme Rejetée",
      EXTEND: "Étendre",
      CONFIG: "Lire les configurations de l'entité",
      IRIS_ENABLE: "Activer 1RIS pour le domaine",
      MARK_TO_PROMOTE: "Marquer l'entité pour Promotion",
      MARK_TO_INVOCE: "Marquer l'entité pour Facturation",
      DELETE: "Supprimer des entités",
      EDIT: "Modifier des entités",
      SUBSCRIPTION_DELETE: "Supprimer des abonnements",
      VAR_HOMEPAGE: 'Page VAR',
      CHANGE_OWNER: 'Changer le propriétaire',
      CONTRACTS: 'Contrats',
      CONTRACT_SERVICES: 'Services de contrat',
      DOWNLOAD_CERTIFICATE: 'Télécharger le certificat',
      PLANTS_READ: 'Lire les systèmes',
      PLANTS_UPDATE: 'Mettre à jour les systèmes',
      PLANTS_CREATE: 'Créer des systèmes',
      PLANTS_DELETE: 'Supprimer des systèmes',
      SYNC_SFDCID: 'Synchroniser avec SFDC',
      UPDATE_ADMIN: 'Mettre à jour l\'administrateur',
      HISTORY_READ: 'Lire l\'historique',
      UPDATE_LOGO: 'Mettre à jour le logo',
      EXPORT_ALL_MANAGERS: 'Exporter tous les administrateurs',
      LEGACY_DOMAINS_READ: 'Lire les domaines hérités',
      TAKE_CHARGE: 'Prendre en charge',
      EDIT_ADMIN: 'Modifier l\'administrateur',
      DEMO_READ: 'Lire les systèmes de démonstration',
      DEMO_CREATE: 'Créer des systèmes de démonstration',
      DEMO_UPDATE: 'Mettre à jour les systèmes de démonstration',
      DEMO_DELETE: 'Supprimer les systèmes de démonstration',
      DEMO_MANAGEMENT: 'Gérer les systèmes de démonstration',
    },
    segmentTypes: {
      WORKING_SPACES_name: "Espace de travail flexible",
      LIVING_name: "Habitat flexible",
      RETAIL_name: "Commerce de détail flexible",
      UNIVERSITIES_name: "Universités",
      LEISURE_name: "Loisirs et hôtellerie",
      HOSPITAL_name: "Hôpital",
      WORKING_SPACES_description: "Bureaux, coworking, centres d'affaires",
      LIVING_description: "Résidentiel, colocation, co-living, logement étudiant",
      RETAIL_description: "Commerce multi-sites, centres commerciaux, chaînes de magasins",
      LEISURE_description: "Hôtels de petite et moyenne taille, hébergement, centres sportifs",
      HOSPITAL_description: "Hôpitaux, résidences pour personnes âgées et soins aux personnes dépendantes",
      deprecated: 'OLD',
      ESTATE_WORKPLACES_REAAS_name: 'Estate - Workplaces - ReaaS [Coworking, Proworking, Business Centers]',
      ESTATE_WORKPLACES_BTR_name: 'Estate - Workplaces - BTR [Single company offices, Hybrid Workplaces, Multi-tenant office buildings, Business Parks]',
      ESTATE_RESIDENTIAL_REAAS_name: 'Estate - Residential - ReaaS [Coliving, Student housing (PBSA), Senior Housing]',
      ESTATE_RESIDENTIAL_BTR_name: 'Estate - Residential - BTR [Multifamily housing, Condos]',
      ESTATE_RESIDENTIAL_BTS_name: 'Estate - Residential - BTS [Multifamily housing, Condos, Cohousing]',
      ESTATE_EDUCATION_name: 'Estate - Education [Schools, Universities]',
      ESTATE_SPORT_FACILITIES_name: 'Estate - Sport Facilities [Arenas, Football stadiums, Tennis courts]',
      ESTATE_MUNICIPALITIES_name: 'Estate - Municipalities [Townhalls, Public Offices]',
      ESTATE_HEALTHCARE_name: 'Estate - Healthcare [Hospitals, Elderly care facilities]',
      ESTATE_RETAIL_MULTI_SITE_name: 'Estate - Retail - Multi site [Pharmacies, Postal Offices, Banks, DIY stores, Fashion, Private clinics]',
      ESTATE_HOSPITALITY_PROFESSIONAL_name: 'Estate - Hospitality - Professional [Big hotels]',
      ESTATE_HOSPITALITY_SMALL_name: 'Estate - Hospitality - Small [Small Hotels, B&Bs, Camping sites]',
      UTILITIES_TELECOM_name: 'Utilities - Telecom [Infrastructure, Operartors]',
      UTILITIES_ELECTRICITY_name: 'Utilities - Electricity [Production, Distribution]',
      'UTILITIES_OIL&GAS_name': 'Utilities - Oil&Gas [Pipes, Transportation]',
      UTILITIES_WATER_name: 'Utilities - Water [Purification, Distribution, Wastewater treatment]',
      UTILITIES_WASTE_name: 'Utilities - Waste [Bio Hazard]',
      UTILITIES_TRANSPORTATION_name: 'Utilities - Transportation [Railways, Subway, Roads, Airports]',
      DEMO_name: 'Demo',
    },
    demoSystem: {
      title: 'Mes systèmes demo',
      name: 'Nom',
      notes: 'Notes',
      url: 'URL',
      peopleUsing: 'Personnes qui utilisent ce demo',
      openNow: 'Ouvrir maintenant',
      noDataTitle: 'Aucun système demo trouvé',
      noDataDescription: 'Il n\'y a pas de systèmes demo disponibles en ce moment',
      newDemoPlantAssociation: 'Assigner un système demo',
      demoPlantAssociationCompleted: 'Système demo assigné avec succès',
      createDemoPlantAssociationError: 'Une erreur est survenue lors de l\'assignation du système demo. Veuillez réessayer',
      deleteDemoPlantAssociation: 'Êtes-vous sûr de vouloir supprimer cette association de système demo ?',
      deleteDemoPlantAssociationConfirm: 'Association de système demo supprimée avec succès',
      deleteDemoPlantAssociationError: 'Une erreur est survenue lors de la suppression de l\'association de système demo. Veuillez réessayer',
      demoPlantAssociationEditedCompleted: 'Association de système demo modifiée avec succès',
      editDemoPlantAssociationError: 'Une erreur est survenue lors de la modification de l\'association de système demo. Veuillez réessayer',
      demoSystemsTitle: 'Systèmes demo',
    },
    agreements: {
      privacyPolicy: 'Politique de Confidentialité',
      termsAndConditions: 'Termes et Conditions',
      acceptAgreements: 'Accepter',
      agreementsUpdated: 'Accords Mis à Jour',
      pleaseAcceptAgreements: 'Veuillez accepter les accords mis à jour pour continuer',
      errorAcceptTermsAndPrivacy: 'Erreur lors de l\'acceptation des termes et de la politique de confidentialité',
    },
    mks: {
      yourRoleDoesNotHavePermissionToImportCsv: 'Votre rôle ne dispose pas des autorisations nécessaires pour importer des fichiers CSV MKS. Veuillez vérifier vos autorisations et réessayer.',
      status_COMPLETED: 'Précédent',
      status_CURRENT: 'Actuel',
      status_ERROR: 'Erreur',
      requestType: 'Type de Demande',
      selectFileFormat: 'Sélectionner le format de fichier',
      importFileFormat_LOCKBASE: 'Lockbase',
      importFileFormat_SUPERLOCK: 'Superlock',
      importFileFormat: 'Format de Fichier d\'Importation',
      mksTitle: 'Master Key Systems',
      cylindersTitle: 'Cylindres',
      keysTitle: 'Clés',
      keyDetails: 'Détails de la clé',
      cylinderDetails: 'Détails du cylindre',
      hostnameRequiredForImportDescription: 'Veuillez saisir un nom d\'installation pour importer les données',
      id: 'ID',
      externalId: 'ID Externe',
      doorName: 'Nom de Porte',
      marking: 'Marquage',
      type: 'Type',
      insideLength: 'Longueur Intérieure',
      outsideLength: 'Longueur Extérieure',
      quantity: 'Quantité',
      quantityKeys: 'Quantité de Clés',
      keyFunction: 'Fonction de Clé',
      designation: 'Désignation',
      companyId: 'ID Entreprise',
      hostnameRequired: 'Nom du système (obligatoire)',
      hostnameRequiredTitle: 'Système Requis',
      hostnameRequiredDescription: 'Veuillez saisir le nom d\'un système pour voir la liste',
      noCylindersFoundTitle: 'Aucun Cylindre Trouvé',
      noCylindersFoundDescription: 'Aucun cylindre n\'a été trouvé pour le système spécifié',
      noKeysFoundTitle: 'Aucune Clé Trouvée',
      noKeysFoundDescription: 'Aucune clé n\'a été trouvée pour le système spécifié',
      filterByType: 'Type de Cylindre',
      filterByDoorName: 'Nom de Porte',
      filterByKeyFunction: 'Fonction de Clé',
      filterByDesignation: 'Désignation de Clé',
      importsTitle: 'Importations',
      noImportsFoundTitle: 'Aucune Importation Trouvée',
      noImportsFoundDescription: 'Aucune importation n\'a été trouvée pour le système spécifié',
      filterByStatus: 'Statut d\'Importation',
      filterByFilename: 'Nom de Fichier',
      uploadCsv: 'Télécharger fichier',
      uploadCsvTitle: 'Télécharger un Fichier',
      dragDropCsv: 'Glissez-déposez votre fichier ici',
      orClickToSelect: 'ou cliquez pour sélectionner un fichier',
      previewCsv: 'Aperçu fichier',
      csvPreviewTitle: 'Aperçu d\'Importation',
      previewSummary: 'Résumé d\'Importation',
      csvHasErrors: 'Le fichier contient des erreurs de validation. Seules les lignes valides seront importées.',
      validationErrors: 'Erreurs de Validation',
      dataPreview: 'Aperçu des Données',
      noValidRowsToImport: 'Aucune ligne valide trouvée pour l\'importation. Veuillez corriger les erreurs et réessayer.',
      confirmImport: 'Confirmer l\'Importation',
      fileInfo: 'Informations sur le Fichier',
      importSummary: 'Résumé d\'Importation',
      filename: 'Nom de Fichier',
      importTimestamp: 'Date d\'Importation',
      status: 'Statut',
      keysImported: 'Clés Importées',
      cylindersImported: 'Cylindres Importés',
      relationsImported: 'Relations Importées',
      errorsCount: 'Nombre d\'Erreurs',
      userEmail: 'Email Utilisateur',
      noKeySelected: 'Aucune clé sélectionnée',
      noCylinderSelected: 'Aucun cylindre sélectionné',
      customAttributes: 'Attributs Personnalisés',
      associatedCylinders: 'Cylindres Associés',
      associatedKeys: 'Clés Associées',
      noAssociatedCylinders: 'Aucun cylindre associé trouvé',
      noAssociatedKeys: 'Aucune clé associée trouvée',
      relationId: 'ID de Relation',
      fileSize: 'Taille du Fichier',
      totalRows: 'Lignes Totales',
      errors: 'Erreurs',
      keys: 'Clés',
      cylinders: 'Cylindres',
      relations: 'Relations',
      currentConfig: 'Configuration Actuelle',
      confirmImportTitle: 'Confirmer l\'Import',
      confirmImportMessage: 'Êtes-vous sûr de vouloir importer ce fichier ?',
      fileName: 'Nom du Fichier',
      warningMessage: 'ATTENTION: Cette opération va complètement écraser la configuration actuelle de l\'installation avec les données de ce fichier CSV. Cette opération est irréversible.',
      comparisonTitle: 'Comparaison avec la Configuration Actuelle',
      currentLabel: 'Actuelle',
      newLabel: 'Nouvelle',
      requestsTitle: 'Demandes MKS',
      newRequest: 'Nouvelle Demande',
      editRequest: 'Modifier la Demande',
      requestManagement: 'Gestion des Demandes',
      requestType_KEY_DUPLICATION: 'Duplication de Clé',
      requestType_CYLINDER_DUPLICATION: 'Duplication de Cylindre',
      requestType_KEY_EXTENSION: 'Extension de Clé',
      requestType_CYLINDER_EXTENSION: 'Extension de Cylindre',
      requestStatus: 'Statut',
      requestStatus_DRAFT: 'Brouillon',
      requestStatus_SENT: 'Envoyée',
      requestStatus_TAKEN_IN_CHARGE: 'Pris en Charge',
      requestStatus_REJECTED: 'Rejetée',
      requestStatus_CANCELED: 'Annulée',
      requestStatus_ORDER_CONFIRMED: 'Commande Confirmée',
      requestStatus_ORDER_SHIPPED: 'Commande Expédiée',
      requestStatus_ORDER_COMPLETED: 'Commande Terminée',
      historyAction_CREATED: 'Créée',
      historyAction_UPDATED: 'Mise à Jour',
      historyAction_STATUS_CHANGED: 'Statut Changé',
      historyAction_STATUS_DRAFT: 'Statut Brouillon',
      historyAction_STATUS_SENT: 'Statut Envoyée',
      historyAction_STATUS_TAKEN_IN_CHARGE: 'Statut Pris en Charge',
      historyAction_STATUS_REJECTED: 'Statut Rejetée',
      historyAction_STATUS_ORDER_CONFIRMED: 'Statut Commande Confirmée',
      historyAction_STATUS_ORDER_SHIPPED: 'Statut Commande Expédiée',
      historyAction_STATUS_ORDER_COMPLETED: 'Statut Commande Terminée',
      historyAction_STATUS_CANCELED: 'Statut Annulée',
      historyAction_NOTES_UPDATED: 'Notes Mises à Jour',
      historyAction_DELIVERY_DATE_UPDATED: 'Date de Livraison Mise à Jour',
      historyAction_DOCUMENTS_ADDED: 'Documents Ajoutés',
      historyAction_DOCUMENTS_REMOVED: 'Documents Supprimés',
      historyAction_CANCELLED: 'Annulée',
      historyAction_COMPLETED: 'Terminée',
      requestNotes: 'Notes',
      requestData: 'Données de Demande (JSON)',
      plantHostname: 'Nom d\'Hôte de l\'Installation',
      companyName: 'Entreprise',
      createdBy: 'Créé Par',
      deliveryDate: 'Date de Livraison',
      plantSearch: 'Rechercher Système',
      plantSearchNoMatch: 'Aucun système trouvé',
      plantSearchEnterName: 'Entrez le nom d\'hôte pour rechercher',
      selectRequestType: 'Sélectionner le Type de Demande',
      requestTypeFilter: 'Filtrer par Type',
      statusFilter: 'Filtrer par Statut',
      sendRequest: 'Envoyer la Demande',
      takeInCharge: 'Prendre en Charge',
      rejectRequest: 'Rejeter',
      confirmOrder: 'Confirmer la Commande',
      shipOrder: 'Expédier la Commande',
      completeOrder: 'Terminer la Commande',
      deleteMKSRequestConfirm: 'Êtes-vous sûr de vouloir annuler cette demande ?',
      changeStatusMKSRequestConfirm: 'Êtes-vous sûr de vouloir changer le statut de cette demande ?',
      requestHistory: 'Historique de la Demande',
      noRequestHistoryFound: 'Aucun Historique Trouvé',
      noRequestHistoryFoundDescription: 'Aucun enregistrement d\'historique trouvé pour cette demande',
      noRequestFindTitle: 'Aucune Demande Trouvée',
      noRequestFindDescription: 'Aucune demande MKS trouvée. Essayez d\'ajuster vos filtres de recherche.',
      exportRequests: 'Exporter les Demandes',
      createMKSRequestConfirm: 'Êtes-vous sûr de vouloir créer cette nouvelle demande MKS ?',
      editMKSRequestConfirm: 'Êtes-vous sûr de vouloir modifier cette demande MKS ?',
      openMKSRequestsError: 'Une erreur s\'est produite lors du chargement des demandes MKS. Veuillez réessayer',
      createMKSRequestError: 'Une erreur s\'est produite lors de la création de la demande. Veuillez réessayer',
      editMKSRequestError: 'Une erreur s\'est produite lors de la mise à jour de la demande. Veuillez réessayer',
      deleteMKSRequestError: 'Une erreur s\'est produite lors de l\'annulation de la demande. Veuillez réessayer',
      changeMKSRequestStatusError: 'Une erreur s\'est produite lors du changement de statut de la demande. Veuillez réessayer',
      seePlant: 'Voir le Système',
      customerName: 'Nom du Client',
      varName: 'Nom VAR',
      length: 'Longueur',
      cylindersList: 'Liste des Cylindres',
      cylindersData: 'Données des Cylindres (JSON)',
      keysList: 'Liste des Clés',
      keysData: 'Données des Clés (JSON)',
      assignedUser: 'Utilisateur Assigné',
      selectAssignedUser: 'Sélectionner l\'Utilisateur Assigné',
      selectCylinders: 'Sélectionner les Cylindres',
      selectKeys: 'Sélectionner les Clés',
      requestFiles: 'Fichiers de Demande',
      rejectedNotes: 'Notes de Rejet',
      setDeliveryDateConfirm: 'Veuillez définir la date de livraison pour cette commande',
      editDeliveryDate: 'Modifier la Date de Livraison',
      editDeliveryDateConfirm: 'Veuillez mettre à jour la date de livraison pour cette commande',
      saveRequestConfirmation: 'Enregistrer la Demande',
      saveRequestConfirmationMessage: 'Voulez-vous enregistrer la demande comme brouillon ou l\'envoyer maintenant?',
      saveRequestConfirmationConfirm: 'Envoyer Maintenant',
      saveRequestConfirmationCancel: 'Enregistrer comme Brouillon',
      createDuplicateKeyRequest: 'Créer une Demande de Duplication de Clé',
      createDuplicateCylinderRequest: 'Créer une Demande de Duplication de Cylindre',
      selectCylinder: 'Sélectionner le Cylindre',
      selectKey: 'Sélectionner la Clé',
      relationsMatrixTitle: 'Matrice des Relations',
      cylinderName: 'Nom du Cylindre',
      noRelationsFoundTitle: 'Aucune Relation Trouvée',
      noRelationsFoundDescription: 'Aucune relation cylindre-clé trouvée pour le système spécifié',
      selectedKey: 'Clé Sélectionnée',
      selectedKeys: 'Clés Sélectionnées',
      selectedCylinder: 'Cylindre Sélectionné',
      plantSearchPlaceholder: 'Rechercher un système',
      keysDuplicates: 'Duplicatas de Clés',
      cylindersDuplicates: 'Duplicatas de Cylindres',
      addKey: 'Ajouter une Clé',
      addCylinder: 'Ajouter un Cylindre',
      duplicateEntry: 'Entrée Duplicata',
      duplicateKey: 'Clé Duplicata',
      duplicateCylinder: 'Cylindre Duplicata',
      noKeysSelected: 'Aucune clé sélectionnée',
      noCylindersSelected: 'Aucun cylindre sélectionné',
      quantityError: 'La quantité doit être un entier supérieur à zéro',
      batchAdd: 'Ajout par Lot',
      batchAddTitleCylinders: 'Ajouter des Cylindres par Lot',
      batchAddTitleKeys: 'Ajouter des Clés par Lot',
      batchAddFilterCylinders: 'Filtrer les cylindres',
      batchAddFilterKeys: 'Filtrer les clés',
      batchAddConfirm: 'Confirmer',
      batchAddCancel: 'Annuler',
      batchAddNoResults: 'Aucun élément trouvé',
      batchAddTooManyResults: 'Trop de résultats (plus de {{limit}}). Veuillez affiner votre filtre de recherche.',
      alreadySelected: 'Déjà sélectionné',
      openAdvancedSelector: 'Ouvrir le Sélecteur Avancé',
      selectCylindersWithCount: 'Sélectionner les Cylindres ({{count}})',
      selectKeysWithCount: 'Sélectionner les Clés ({{count}})',
      selectedItemsCount: '{{count}} éléments sélectionnés',
      itemsWillBeAdded: '{{count}} éléments seront ajoutés',
      addItems: 'Ajouter des Éléments ({{count}})',
      generatePdf: 'Générer PDF',
      requestPdf: 'PDF de Demande',
      pdfGenerationError: 'Une erreur s\'est produite lors de la génération du PDF. Veuillez réessayer',
      generateXlsx: 'Générer Excel',
      xlsxGenerationError: 'Une erreur s\'est produite lors de la génération du fichier Excel. Veuillez réessayer',
      generateDocx: 'Générer Word',
      docxGenerationError: 'Une erreur s\'est produite lors de la génération du document Word. Veuillez réessayer',
      exportRequest: 'Exporter la Demande',
      field: 'Champ',
      value: 'Valeur',
    },
    developers: {
      integrationInfo: 'Information d\'intégration',
      api: 'API',
      sdk: 'SDK',
      knx: 'KNX',
      developersResource: 'Ressources développeurs',
    },
    iseoSalesApps: {
      launchpadMissingToken: 'Impossible de lire le jeton de session Vasho. Reconnectez-vous et ouvrez Sales Apps depuis le menu.',
      missingBaseUrl: 'L\'URL de base Sales Apps n\'est pas configurée. Définissez-la dans Vasho Settings.',
    },
    settings: {
      title: 'Configuration',
      salesAppVersion: 'Version de Sales Apps',
      salesAppVersionDescription: 'URL de base help-center (p. ex. …/sales-apps/v122) ou launchpad (p. ex. …/launchpad).',
      save: 'Enregistrer',
      saveSuccess: 'Configuration enregistrée avec succès',
      saveError: 'Impossible d\'enregistrer la configuration. Veuillez réessayer',
      invalidValue: 'Veuillez entrer une valeur valide',
    },
  };
  
export default translations; 